import React, { useState, useEffect, useContext, useRef } from "react";
import Container from "../../components/layout/Container/Container";
import Footer from "../../components/molecules/Footer/Footer";
import Header from "../../components/molecules/Header/Header";
import { useNavigate, useLocation } from "react-router-dom";
import { defaultAppContextData } from "../../services/appData";
import { IChooseApp } from "../../typings/models/ChooseApp";
import Select from "react-select";
import { useContextService } from "../../services";
import { PremiseCodeDetails } from "../../api/apimethods";
import {
  SaveENVDraftApplications,
  getBioCountryOfDestination,
  getBioCountryOfOrigin,
  getENVApplication,
  getPshCavsTestCodeMaster,
  saveENVCancellation,
  getBreedSpeciesSpecimensDetails,
  saveResultRequest,
  saveAckRequest,
  getAmendmentHistory,
} from "../../api/apimethods";
import { notify } from "../../utils";
import {
  IFilerInformation,
  tempFilerInfo,
} from "../../typings/models/FilerInformation";
import { ENVMetaContext } from "../../App";
import { IStepwizardProps } from "../../typings/models/StepwizardProps";
import Stepwizard from "../LabDetails/Helper/Stepwizard";
import moment from "moment";
import { IENVSamplesAndTests } from "../../typings/models/ENVSamplesandTests";
import { Button, Modal, Spinner, Tab, Tabs } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IPersonalInfo } from "../../typings/models/PersonalInfo";
import { getCAVSMaster } from "../../api/apimethods";
import { ICAVSMaster } from "../../typings/models/CAVSMaster";
import { ENVPurposeOfTest } from "../../typings/models/ENVPurposeOfTest";
import { IENVSampleDetails } from "../../typings/models/ENVSampleDetails";
import { ILabTestDetails } from "../../typings/models/LabTestDetails";
import { IAmendmentHistoryResponse } from "../../typings/interfaces/Responses/LabApplicationsResponse";
import AmendmentGrid from "./AmendmentGrid";
import { ErrMsg, NotifyType } from "../../utils/app-config";
import PersonalInformation, {
  initialPersonalInfo,
} from "./Helper/ProfileInformation";
import {
  IENVRequest,
  defENVCancelAppStatus,
} from "../../typings/interfaces/Requests/ENVRequest";
import { IENVApplicationDetails } from "../../typings/models/ENVApplicationDetails";
import { helper } from "../../utils/helper";
import { useSearchParams } from "react-router-dom";
import { IlabENVPreference } from "../../typings/models/ENVPreference";
import { faCopy, faTrashCan } from "@fortawesome/free-regular-svg-icons";
import {
  faCircleExclamation,
  faInfoCircle,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { ApplicationStatus, TypeOfApplicationEnum, ApplicationTypeEnum } from "../../utils/enum";
import { ITestPshCavsCodeMasterModel } from "../../typings/models/PshCavsTestCodeMasterModel";
import { IBioMaster } from "../../typings/models/BioMaster";
import { ICodeMasterModel } from "../../typings/models/CodeMasterModel";
import FileSaver from "file-saver";
import { ILabSpeciesMaster } from "../../typings/models/LabSpeciesMaster";
import { ILabBreedMaster } from "../../typings/models/LabBreedMaster";
import { ILabSpecimenMaster } from "../../typings/models/LabSpecimenMaster";
import { IReactSelectOption } from "../../typings/models/ReactSelectOption";
import { IBioPurposeOfTest } from "../../typings/models/BioPurposeOfTest";
import { ITestResult } from "../../typings/interfaces/Requests/TestResult";
import Loader from "../../components/molecules/Loader";
enum sampleDetailMandatoryFields {
  purposeTest = "purposeTest",
  samplingFromDate = "samplingFromDate",
  samplingToDate = "samplingToDate",
  sampledBy = "sampledBy",
}

enum SamplesAndTestMandatoryFields {
  sampleMarking = "sampleMarking",
  species = "species",
  labENVTestDetails = "labENVTestDetails",
}
enum PreferenceMandatoryFields {
  modeOfReceiving = "modeOfReceiving",
}

enum ResultMandatoryFields {
  resultcode = "resultcode",
  testingInstructions = "testingInstructions",
  remarksForThirdParty = "remarksForThirdParty",
}

type RepeatCounts = {
  [sampleIndex: number]: {
    [testIndex: number]: number;
  };
};
function CAVSENVSampleDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state as { selectedType: string };
  const [params, setParams] = useSearchParams();
  const [selectedTestIds, setSelectedTestIds] = useState<
    (number | undefined)[]
  >([]);
  const [repeatCounts, setRepeatCounts] = useState<RepeatCounts>({});
  const [activeTab, setActiveTab] = useState<number>(1);
  const [amendCase, setAmendCase] = useState<string>("");
  const [rejectedTestsMessage, setRejectedTestsMessage] = useState("");
  const [testStatus, setTestStatus] = useState<string>("");
  const [addressType, setAddressType] = useState<string>("");
  const [isCancelRequest, setIsCancelRequest] = useState<boolean>(false);
  const [cancelComments, setCancelComments] = useState<string>("");
  const [cancelCommentsErrMsg, setCancelCommentsErrMsg] = useState<string>("");
  const [searchInd, setSearchInd] = useState(-1);
  const [customerName, setCustomerName] = useState<string>("");
  const [IsBiosurvillanceUser, setIsBiosurvillanceUser] = useState(false);
  const [salutation, setSalutation] = useState<string>("");
  const [showFarmDetails, setShowFarmDetails] = useState(true);
  const [showForm, setShowForm] = useState(true);
  const [cancelButtonHidden, setCancelButtonHidden] = useState(false);
  const [validDates, setValidDates] = useState<boolean>(false);
  const [submittedFeedback, setSubmittedFeedback] = useState<number>(0);
  const [purposeOfTestOptions, setPurposeOfTestOptions] =
    useState<ENVPurposeOfTest[]>();
  const [showPlaceholder, setShowPlaceholder] = useState(true);
  const [ResultCodeOptions, setResultCodeOptions] = useState<
    IReactSelectOption[]
  >([]);
  const [originalSampleDetails, setOriginalSampleDetails] =
    useState<IENVSampleDetails | null>(null);
  const [originalSamplesAndTests, setOriginalSamplesAndTests] = useState<
    IENVSamplesAndTests[]
  >([]);
  const [modeOfPayment, setModeOfPayment] = useState<string>(
    localStorage.getItem("modeOfPayment") || ""
  );
  const { getContextValueFromStorage } = useContextService();
  const [contextData] = useState(() =>
    getContextValueFromStorage(defaultAppContextData)
  );
  const user = contextData.user;
  const [personalInfo, setPersonalInfo] =
    useState<IPersonalInfo>(initialPersonalInfo);
  const [cancelMessage, setcancelMessage] = useState<string | null>(null);
  const [searchLoading, setSearchLoading] = useState<boolean>(false);
  const [countryOfOriginOptions, setCountryOfOriginOptions] =
    useState<ICodeMasterModel[]>();
  const [countryOfDestinationOptions, setCountryOfDestinationOptions] =
    useState<ICodeMasterModel[]>();
  const [labtestoptions, setlabtestoptions] = useState<
    ITestPshCavsCodeMasterModel[]
  >([]);
  const [countryOptions, setCountryOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [clinicalHistoryOptions, setClinicalHistoryOptions] =
    useState<IBioPurposeOfTest[]>();
  const [RedMessage, setRedMessage] = useState("");
  const [isPostMartem, setIsPostMartem] = useState(0);
  const [labTestID, setlabTestID] = useState<string>("");
  const [customerNRIC, setCustomerNRIC] = useState("");
  const [hasFetchedInitialData, setHasFetchedInitialData] = useState(false);
  const { ENVMeta } = useContext(ENVMetaContext);
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate());
  const maxdate = currentDate.toISOString().split("T")[0];
  const maxDateTime = currentDate.toISOString().slice(0, 16);
  const [acknowledgmentMessage, setAcknowledgmentMessage] = useState<
    string | null
  >(null);
  const [speciesSelectOptions, setSpeciesSelectOptions] = useState<
    IReactSelectOption[]
  >([]);
  const [breedSelectOptions, setBreedSelectOptions] = useState<
    IReactSelectOption[]
  >([]);
  const [specimenSelectOptions, setSpecimenSelectOptions] = useState<
    IReactSelectOption[]
  >([]);
  const [IsAcknowledgeRequest, setIsAcknowledgeRequest] =
    useState<boolean>(false);
  const [IsAcknowledge, setIsAcknowledge] = useState<boolean>(false);
  const [IsSubmitresultRequest, setIsSubmitresultRequest] =
    useState<boolean>(false);
  const [btnNameForLoader, setBtnNameForLoader] = useState<string>("");
  const handleLoader = (enableLoader: boolean, btnNameOfLoader: string) => {
    setBtnNameForLoader(enableLoader ? btnNameOfLoader : "");
  };
  const [showSearchTestsModal, setShowSearchTestsModal] =
    useState<boolean>(false);
  const [testDescription, setTestDescription] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showAmendmentHistory, setShowAmendmentHistory] = useState(false);
  const [amendmentHistory, setAmendmentHistory] = useState<IAmendmentHistoryResponse[]>([]);
  const [testOptions, setTestOptions] = useState<ITestPshCavsCodeMasterModel[]>(
    []
  );
  const [BioSurveillanceValues, setBioSurveillanceValues] = useState<string[]>(
    []
  );
  const [bioSurveillanceProgramsOptions, setBioSurveillanceProgramsOptions] =
    useState<IReactSelectOption[]>([]);
  const [premisesCodeOptions, setpremisesCodeOptions] = useState<
    IReactSelectOption[]
  >([]);
  const [actionType, setActionType] = useState<string>("");
  const [isThirdPartyLab, setisThirdPartyLab] = useState<string>("");
  const [thirdPartyNric, setthirdPartyNric] = useState<string>("");
  const [applicationNum, setApplicationNum] = useState<string>("");
  const [acknowledgmentNumber, setAcknowledgmentNumber] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showTooltip, setShowTooltip] = useState(false);
  const [copyCount, setCopyCount] = useState<number>(1);
  const { btnLoaderHandler, fileToBase64, getFilerInfomation } = helper();
  const [speciesOptions, setSpeciesOptions] = useState<ILabSpeciesMaster[]>();
  const [breedOptions, setBreedOptions] = useState<ILabBreedMaster[]>();
  const [specimenOptions, setSpecimenOptions] =
    useState<ILabSpecimenMaster[]>();
  const [selectedTestLaboratory, setSelectedTestLaboratory] =
    useState("All-laboratories");
  const { message } = notify();
  const testRowId = Number(params.get("rowId") ?? "");
  const [reportgenerated, setreportgenerated] = useState<number>(0);
  const postMartemFields = [
    "resultcode",
    "testingInstructions",
    "remarksForThirdParty",
  ];
  const stripHtmlTags = (str: string) => {
    return str.replace(/<\/?([a-z][a-z0-9]*)\b[^>]*>/gi, "");
  };
  const strippedHtmlTags = (str: string) => {
    return str.replace(/<\/?[^>]+(>|$)/g, "").trim();
  };
  let labENVPreferenceSchema: IlabENVPreference = {
    specialInstructions: "",
    antimicrobialSusceptibilityTestRequired: false,
    remarks: "",
    supportDocuments: [],
    supportDocumentName: "",
    hardcopy: "",
    noOfHardCopies: 1,
    acknowledge: false,
    customAddress: "",
    modeOfReceiving: 0,
  };
  const reportTypeNames: { [key: number]: string } = {
    1: "Casesheet",
    2: "Laboratory Report",
    3: "Acknowledgment Slip",
    4: "Sample Label",
  };
  const [reports, setReports] = useState<
    {
      reportName: string;
      reportData: string;
      reportType: number;
      reportID: string;
      applicationId: string;
      isReportGenerated: any;
    }[]
  >([]);
  const renderReportType = (type: number) => {
    return reportTypeNames[type] || "Laboratory Report";
  };
  const [Preference, setPreference] = useState<IlabENVPreference>(
    labENVPreferenceSchema
  );
  const prevModeOfPaymentRef = useRef(modeOfPayment);
  useEffect(() => {
    if (modeOfPayment === "Biosurveillance") {
      setENVSampleDetails((prevDetails) => ({
        ...prevDetails,
        purposeTest: 1,
      }));
    } else if (prevModeOfPaymentRef.current === "Biosurveillance") {
      setENVSampleDetails((prevDetails) => ({
        ...prevDetails,
        purposeTest: 0,
      }));
    }

    prevModeOfPaymentRef.current = modeOfPayment;
  }, [modeOfPayment]);

  const [originalPreference, setOriginalPreference] =
    useState<IlabENVPreference>(labENVPreferenceSchema);
  const handleMouseEnter = () => {
    setShowTooltip(true);
  };
  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  const getENVRequestSchema = (): IENVRequest => {
    delete ENVSampleDetails?.samplesCollectedOrSubmittedErrMsg;
    delete ENVSampleDetails?.purposeTestErrMsg;
    delete ENVSampleDetails?.otherPurposeOfTestErrMsg;
    delete ENVSampleDetails?.samplingFromDateErrMsg;
    delete ENVSampleDetails?.samplingToDateErrMsg;
    delete ENVSampleDetails?.sampledByErrMsg;
    delete ENVSampleDetails?.bioSurveillanceProgramErrMsg;
    let sampleRowId = 1;
    const updatedSamples = samplesAndTests.map((sample) => {
      let testRowId = 1;
      const updatedSample = {
        ...sample,
        rowId: sampleRowId,
        sampleRowId: sampleRowId++,
        labENVTestDetails: sample.labENVTestDetails?.map((test) => ({
          ...test,
          rowId: testRowId,
          testRowId: testRowId++,
        })),
      };
      return updatedSample;
    });

    let chooseAppMeta: IChooseApp = {
      typeOfService: "CAVS Laboratory Services",
      typeOfApplication: "ENV",
      applicationType: 0
    };

    samplesAndTests.forEach((x) => {
      delete x.id;
      delete x?.sampleMarkingErrMsg;
      delete x?.speciesErrMsg;
      delete x?.breedErrMsg;
      delete x?.specimenDescriptionErrMsg;
      delete x?.labENVTestDetailsErrMsg;
      delete x?.disableDelete;
      x?.labENVTestDetails?.forEach((element: any) => {
        delete element?.disableDelete;
      });
    });
    const modifiedBioDetails = originalSampleDetails
      ? getModifiedValues(originalSampleDetails, ENVSampleDetails)
      : ENVSampleDetails;
    const modifiedSamplesAndTests = getModifiedSamplesAndTests(
      originalSamplesAndTests,
      samplesAndTests
    );
    const modifiedPreference = getModifiedPreference(
      originalPreference,
      Preference
    );
    const filerInfo: IFilerInformation | null = getFilerInfomation();
    let personalInfo: IPersonalInfo = JSON.parse(
      localStorage.getItem("profile-info") || ""
    );

    let meta: IENVRequest = {
      labENVChooseApplDetails: chooseAppMeta,
      labENVPersonalInfoDetails: personalInfo,
      labENVApplicationDetails: {
        ...ENVSampleDetails,
      } as IENVSampleDetails,
      labApplicationchangedDetails: modifiedBioDetails as IENVSampleDetails,
      labchangedSampleTestDetails: modifiedSamplesAndTests,
      labChangedPreference: modifiedPreference,
      labENVSampleTests: updatedSamples,
      labENVPreference: Preference,
      actionStatus: actionType || "",
      labENVFilerInfoDetails: filerInfo || tempFilerInfo,
    };
    if (meta.actionStatus !== TypeOfApplicationEnum.submit) {
      meta.applicationNumber = applicationNum || "";
    }

    return meta;
  };
  const storeInContext = async () => {
    try {
      let meta: IENVRequest = await getENVRequestSchema();

      ENVMeta.updateENVMeta(meta);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    if (speciesOptions) {
      const speciesOpts = speciesOptions.map((species) => ({
        label: species.speciesName,
        value: species.speciesName,
      }));
      setSpeciesSelectOptions(speciesOpts);
    }

    if (breedOptions) {
      const breedOpts = breedOptions.map((breed) => ({
        label: breed.breedName,
        value: breed.breedName,
      }));
      setBreedSelectOptions(breedOpts);
    }

    if (specimenOptions) {
      const specimenOpts = specimenOptions.map((specimen) => ({
        label: specimen.labSpecimenDescription,
        value: specimen.labSpecimenDescription,
      }));
      setSpecimenSelectOptions(specimenOpts);
    }
  }, [speciesOptions, breedOptions, specimenOptions]);

  const handleSelectChange =
    (index: number, name: string) =>
    (selectedOption: IReactSelectOption | null) => {
      const event = {
        target: {
          name,
          value: selectedOption ? selectedOption.value : "",
        },
      };
      handleSamplesAndTestsChange(index, "string")(event as any);
    };

  const handledSelectChange =
    (index: number, name: string, testIndex: string, resultIndex: number) =>
    (selectedOption: IReactSelectOption | null) => {
      const event = {
        target: {
          name,
          value: selectedOption ? selectedOption.value : "",
        },
      };
      handledSamplesAndTestsChange(
        index,
        "string",
        testIndex,
        resultIndex
      )(event as any);
    };

  const handleSelectedChange =
    (name: string) => (selectedOption: IReactSelectOption | null) => {
      const event = {
        target: {
          name,
          value: selectedOption ? selectedOption.value : "",
        },
      } as React.ChangeEvent<HTMLSelectElement>;
      handleENVSampleDetails(event, "string");
    };

  const handleDownload = (fileName: string, reportData: string, index: number, totalReports: number,  applicationNum: string) => {
      try {
        const decodedData = atob(reportData);
        const byteCharacters = Array.from(decodedData).map((char) =>
          char.charCodeAt(0)
        );
        const byteArray = new Uint8Array(byteCharacters);
  
        const blob = new Blob([byteArray], { type: "application/pdf" });
  
        FileSaver.saveAs(blob, fileName);
  
      // ✅ Redirect only if this is the last record
      if (index === totalReports - 1) {
        setTimeout(() => {
          window.location.href = `/eservices/rating-feedback?an=${encodeURIComponent(applicationNum)}`;
        }, 800);
      }
        //window.location.href = `/eservices/rating-feedback?an=${applicationNum}`;
      } catch (error) {
        console.error(error);
        message(NotifyType.Info, "Error downloading the file");
      }
    };    

  const validateForm = (e: React.FormEvent) => {
    e.preventDefault();
    let isValidAppDetils = true;
    let overAllValidFlag = true;
    let personalInfostorage: IPersonalInfo = { ...initialPersonalInfo };
    try {
      const storedProfileInfo = localStorage.getItem("profile-info");
      if (storedProfileInfo) {
        personalInfostorage = JSON.parse(storedProfileInfo);
      }
    } catch (error) {
      console.error("Error parsing profile-info from localStorage:", error);
    }

    if (!validDates) {
      overAllValidFlag = false;
      message(NotifyType.Error, "Please enter valid sampling date fields.");
    }

    if (!sampleDetailMandatoryFields || !SamplesAndTestMandatoryFields) {
      console.error("Mandatory fields configuration is missing.");
      return;
    }

    const applicationDetailsManFields = Object.values(
      sampleDetailMandatoryFields
    );
    let tempApplicationDetails: any = ENVSampleDetails;

    applicationDetailsManFields.forEach((x: any) => {
      const temp = tempApplicationDetails[x];
      if (typeof temp === "number") {
        if (!temp) {
          isValidAppDetils = false;
          tempApplicationDetails = {
            ...tempApplicationDetails,
            [`${x}ErrMsg`]: `Please fill ${x}.`,
          };
        } else {
          tempApplicationDetails = {
            ...tempApplicationDetails,
            [`${x}ErrMsg`]: ``,
          };
        }
      } else {
        if (!temp?.length) {
          isValidAppDetils = false;
          tempApplicationDetails = {
            ...tempApplicationDetails,
            [`${x}ErrMsg`]: `Please fill ${x}.`,
          };
        } else {
          tempApplicationDetails = {
            ...tempApplicationDetails,
            [`${x}ErrMsg`]: ``,
          };
        }
      }
    });
    if (ENVSampleDetails?.purposeTest === 1) {
      if (!ENVSampleDetails?.bioSurveillanceProgram?.length) {
        isValidAppDetils = false;
        tempApplicationDetails = {
          ...tempApplicationDetails,
          bioSurveillanceProgramErrMsg:
            "Please select a Biosurveillance Program.",
        };
      } else {
        tempApplicationDetails = {
          ...tempApplicationDetails,
          bioSurveillanceProgramErrMsg: "",
        };
      }
    }

    setENVSampleDetails(tempApplicationDetails);
    if (!isValidAppDetils) {
      overAllValidFlag = false;
    }

    let isValidSampleAndTests = true;
    const manFieldsSampleAndTests = Object.values(
      SamplesAndTestMandatoryFields
    );
    const sampleMarkingsAll = samplesAndTests
      .map((s: any) => s.sampleMarking?.trim())
      .filter(Boolean);
    const duplicates = sampleMarkingsAll.filter(
      (mark, idx, arr) =>
        arr.indexOf(mark) !== idx && arr.lastIndexOf(mark) === idx
    );
    const newArray = samplesAndTests.map((item: any) => {
      manFieldsSampleAndTests.forEach((x: any) => {
        const temp = item[x];
        if (typeof temp === "number") {
          if (!temp) {
            isValidSampleAndTests = false;
            item = { ...item, [`${x}ErrMsg`]: `Please fill ${x}.` };
          } else {
            item = { ...item, [`${x}ErrMsg`]: `` };
          }
        } else {
          if (!temp?.length) {
            isValidSampleAndTests = false;
            item = { ...item, [`${x}ErrMsg`]: `Please fill ${x}.` };
          } else {
            item = { ...item, [`${x}ErrMsg`]: `` };
          }
        }
      });
      const trimmedMark = item.sampleMarking?.trim();
      if (!trimmedMark) {
        isValidSampleAndTests = false;
        item = { ...item, sampleMarkingErrMsg: "Please fill Sampling Marking" };
      } else if (duplicates.includes(trimmedMark)) {
        isValidSampleAndTests = false;
        item = {
          ...item,
          sampleMarkingErrMsg:
            "Sample Marking must be unique across all samples.",
        };
      } else {
        item = { ...item, sampleMarkingErrMsg: "" };
      }
      if (IsSubmitresultRequest) {
        item.labENVTestDetails.forEach((test: any) => {
          if (test.labENVTestResult) {
            test.labENVTestResult = test.labENVTestResult.map((result: any) => {
              if (!result.resultcode) {
                isValidSampleAndTests = false;
                return {
                  ...result,
                  resultcodeErrMsg: "Please fill Result Code.",
                };
              } else {
                return {
                  ...result,
                  resultcodeErrMsg: "",
                };
              }
            });
          }
        });
      }

      return item;
    });

    setSamplesAndTests(newArray);

    if (!isValidSampleAndTests) {
      overAllValidFlag = false;
    }

    let isValidPreferences = true;
    let preferenceFields = Object.values(PreferenceMandatoryFields);
    let tempPreferences: any = Preference;

    preferenceFields.forEach((x: any) => {
      let temp = tempPreferences[x];
      if (typeof temp === "number") {
        if (!temp) {
          isValidPreferences = false;
          tempPreferences = {
            ...tempPreferences,
            [`${x}ErrMsg`]: `Please fill ${x}.`,
          };
        } else {
          tempPreferences = {
            ...tempPreferences,
            [`${x}ErrMsg`]: ``,
          };
        }
      } else {
        if (!temp?.length) {
          isValidPreferences = false;
          tempPreferences = {
            ...tempPreferences,
            [`${x}ErrMsg`]: `Please fill ${x}.`,
          };
        } else {
          tempPreferences = {
            ...tempPreferences,
            [`${x}ErrMsg`]: ``,
          };
        }
      }
    });

    if (!Preference?.modeOfReceiving) {
      isValidPreferences = false;
      tempPreferences = {
        ...tempPreferences,
        modeOfReceivingErrMsg: "Please select Mode of Receiving.",
      };
    } else {
      tempPreferences = { ...tempPreferences, modeOfReceivingErrMsg: "" };

      if (Preference?.modeOfReceiving === 1) {
        if (!Preference?.mailingAddress) {
          isValidPreferences = false;
          tempPreferences = {
            ...tempPreferences,
            mailingAddressErrMsg: "Please select the mailing address.",
          };
        } else if (
          Preference.mailingAddress === 3 &&
          !Preference?.customAddress?.length
        ) {
          isValidPreferences = false;
          tempPreferences = {
            ...tempPreferences,
            customAddressErrMsg: "Please enter the custom address.",
          };
        } else {
          tempPreferences = {
            ...tempPreferences,
            mailingAddressErrMsg: "",
            customAddressErrMsg: "",
          };
        }

        if (!Preference?.acknowledge) {
          isValidPreferences = false;
          tempPreferences = {
            ...tempPreferences,
            acknowledgeErrMsg: "You must acknowledge before proceeding.",
          };
        } else {
          tempPreferences = { ...tempPreferences, acknowledgeErrMsg: "" };
        }
      }
    }

    setPreference(tempPreferences);

    if (personalInfostorage) {
      if (!personalInfostorage?.address?.streetName?.trim()) {
        isValidPreferences = false;
        message(
          NotifyType.Error,
          "Please fill the mailing address street name fields."
        );
      }
      if (!personalInfostorage?.address?.postalCode?.trim()) {
        isValidPreferences = false;
        message(
          NotifyType.Error,
          "Please fill the mailing address postal code fields."
        );
      }

      if (!personalInfostorage?.contact?.salutation) {
        isValidPreferences = false;
        message(NotifyType.Error, "Please fill Salutation.");
      }
      if (!personalInfostorage?.contact?.email) {
        isValidPreferences = false;
        message(NotifyType.Error, "Please fill Email.");
      }
    }

    if (!isValidPreferences) overAllValidFlag = false;

    if (overAllValidFlag) {
      handleNextClick();
    } else {
      message(NotifyType.Error, "Please fill the mandatory fields.");
    }
  };
  const handleToggleForm = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setShowForm((prevShowForm) => !prevShowForm);
  };

  const handleMyPreference = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >,
    type: string
  ) => {
    setPreference((prevState) => {
      const target = e.target as HTMLInputElement;
      let value: string | boolean | number = target.value;

      switch (type) {
        case "radio":
          value = parseInt(target.value, 10);
          break;
        case "number":
          value = target.value ? parseInt(target.value, 10) : 1;
          break;
        case "checkbox":
          value = target.checked;
          break;
        default:
          break;
      }

      return {
        ...prevState,
        [target.name]: value,
      } as IlabENVPreference;
    });
  };
  const fetchLabTestOptions = async () => {
    try {
      const labMastersResponse: any = await getPshCavsTestCodeMaster({
        PurposeCode: "ENV",
        IsBiosurvillanceUser: IsBiosurvillanceUser,
      });
      const labMastersData = labMastersResponse.data;
      const labTestOptions = labMastersData.cavsLabMasters.map((item: any) => ({
        labGroupId: item.labGroupId,
        title: item.title,
        labGroup: item.labGroup,
      }));

      setlabtestoptions(labTestOptions);
    } catch (error) {
      console.error("Error fetching lab test options:", error);
    }
  };

  useEffect(() => {
    fetchLabTestOptions();
  }, []);

  useEffect(() => {
    btnLoaderHandler(btnNameForLoader ? true : false);
  }, [btnNameForLoader]);
  const [pageLoader, setPageLoader] = useState<boolean>(false);
  const [checkpageLoader, setcheckPageLoader] = useState<boolean>(false);
  const stepWizardConfig: IStepwizardProps = {
    currentStep: 2,
    steps: [
      {
        name: "Choose Application",
      },

      {
        name: "Samples & Tests",
      },
      {
        name: "Review",
      },
      {
        name: "Cost & Confirm",
      },
      {
        name: "Acknowledgement",
      },
    ],
  };

  const [ENVSampleDetails, setENVSampleDetails] =
    useState<IENVApplicationDetails>({
      purposeTest: 0,
      otherPurposeOfTest: "",
      crossReference: "",
      samplesCollectedOrSubmitted: "Tobesubmitted",
      samplingFromDate: null,
      samplingToDate: null,
      sampledBy: "",
      specialFarmCode: "",
      latitude: "",
      longitude: "",
      courierName: "",
      courierTrackingNo: "",
      countryofOrigin: "",
      importLicenseNumber: "",
      dateOfManufacture: null,
      dateOfImport: null,
      dateToBeExported: null,
      locationName: "",
      addressType: "",
      postalCode: "",
      streetName: "",
      blockHouseNo: "",
      level: "",
      farmCode: "",
      unitNo: "",
      buildingName: "",
      cityName: "",
      state: "",
      country: "",
      histrory_Remarks: "",
      referringVeterinarian: "",
      bioSurveillanceProgram: "",
    });

  const [postalCode, setpostalCode] = useState({
    postalCode: "",
    streetName: "",
    blockHouseNo: "",
    buildingName: "",
    CityName: "",
    state: "",
    unitNo: "",
  });
  const defaultTestResult: ITestResult = {
    resultcode: "",
    Readings: 0,
    Readings2: 0,
    Symbol1: 0,
    Symbol2: 0,
    Positive: "",
    Negative: "",
    Indefinite: "",
    ResultRemarks: "",
    report: "",
    Parasitology: "",
    Microbiology: "",
    Histopathology: "",
    ourreference: "",
    finalDiagnosis: "",
    testingInstructions: "",
    remarksForThirdParty: "",
    units: "",
  };
  const mergeWithDefaults = (result: any) => ({
    ...defaultTestResult,
    ...result,
  });

  const getMaster = async () => {
    try {
      setPageLoader(true);
      const getUserInfo = localStorage.getItem("app-data");
      const userInfo = JSON.parse(getUserInfo || "");
      let NRIC = userInfo?.user?.idNo || null;
      let UEN = userInfo?.user?.uen || null;
      let role = userInfo?.user?.role || "";
      setCustomerNRIC(role === "CorpPass" ? UEN : NRIC);
      const customerIdentifier = role === "CorpPass" ? UEN : NRIC;
      const response = await getCAVSMaster();
      if (response?.status == 200) {
        let cavsMaster: ICAVSMaster = response.data;
        let bioMaster: IBioMaster = cavsMaster.bioMasters;
        if (bioMaster) {
          let purposeTest = bioMaster.testPurpose;
          let values: number[] = Object.values(purposeTest);
          let purposeTestArr = Object.keys(purposeTest).map((x, ind) => {
            return {
              id: values[ind],
              name: x,
            };
          });
          if (bioMaster.bioSurveillances) {
            const fetchedBioSurveillanceValues = bioMaster.bioSurveillances.map(
              (service: any) => service.uen
            );
            setBioSurveillanceValues(fetchedBioSurveillanceValues);
            const isBioUser =
              Array.isArray(fetchedBioSurveillanceValues) &&
              fetchedBioSurveillanceValues.includes(customerIdentifier);
            setIsBiosurvillanceUser(isBioUser);
          }

          setPurposeOfTestOptions(purposeTestArr);
          const resultCode = bioMaster.resultCodeMaster;
          if (resultCode) {
            const resultCodeArr = resultCode.map((result: any) => ({
              label: result.resultCodeName,
              value: result.resultCodeId,
            }));
            setResultCodeOptions(resultCodeArr);
          }
          const bioSurveillanceProgram = bioMaster.bioSurveillancePrograms;
          if (bioSurveillanceProgram) {
            const bioSurveillanceProgramArr = bioSurveillanceProgram.map(
              (result: any) => ({
                label: result.name,
                value: result.CodeValue,
              })
            );
            setBioSurveillanceProgramsOptions(bioSurveillanceProgramArr);
          }
          const premisesMaster = bioMaster.premisesMaster;
          if (premisesMaster) {
            const premisesCodeOptions = premisesMaster.map((result: any) => ({
              label: result.premisesCode,
              value: result.premisesCode,
            }));

            setpremisesCodeOptions(premisesCodeOptions);
          }
        }
      }

      const countryRes = await getBioCountryOfDestination();
      setCountryOfDestinationOptions(countryRes?.data || []);
      const profileInfo = localStorage.getItem("profile-info");
      if (profileInfo) {
        const parsedProfileInfo = JSON.parse(profileInfo);
        const nric = parsedProfileInfo.customerNRIC;
      }
      const breedspeciesresponse = await getBreedSpeciesSpecimensDetails("ENV");

      if (breedspeciesresponse.status == 200) {
        let species = breedspeciesresponse?.data?.labSpecies;

        if (species) {
          let values: any[] = Object.values(species);
          let speciesArr: any[] = Object.keys(species).map((x, ind) => {
            return {
              speciesName: values[ind].speciesName,
            };
          });
          setSpeciesOptions(speciesArr);
        }

        let breeds = breedspeciesresponse?.data?.labBreed;

        if (breeds) {
          let values: any[] = Object.values(breeds);
          let breedArr: any[] = Object.keys(breeds).map((x, ind) => {
            return {
              breedName: values[ind].breedName,
            };
          });
          setBreedOptions(breedArr);
        }

        let specimens = breedspeciesresponse?.data?.labSpecimen;

        if (specimens) {
          let values: any[] = Object.values(specimens);
          let specimensArr: any[] = Object.keys(specimens).map((x, ind) => {
            return {
              labSpecimenDescription: values[ind].labSpecimenDescription,
            };
          });
          setSpecimenOptions(specimensArr);
        }
      }

      const conutryRes = await getBioCountryOfOrigin();
      setCountryOfOriginOptions(conutryRes?.data || []);

      const countryOptions = (conutryRes?.data || []).map((country) => ({
        value: country.name,
        label: country.name,
      }));
      setCountryOptions(countryOptions);
      let clinicalHistory = response?.data?.bioMasters?.clinicalHistory;
      if (clinicalHistory) {
        let values: number[] = Object.values(clinicalHistory);
        let clinicalHistoryArr: IBioPurposeOfTest[] = Object.keys(
          clinicalHistory
        ).map((x, ind) => {
          return {
            id: values[ind],
            name: x,
          };
        });
        setClinicalHistoryOptions(clinicalHistoryArr);
      }

      const meta: IENVRequest = ENVMeta.ENVMeta;
      if (Object.keys(meta)?.length) {
        setENVSampleDetails(meta.labENVApplicationDetails as any);
        setSamplesAndTests(meta.labENVSampleTests);
        setPreference(meta?.labENVPreference);
        const fromDate = meta.labENVApplicationDetails.samplingFromDate;
        const toDate = meta.labENVApplicationDetails.samplingToDate;

        if (moment(fromDate).isValid() && moment(toDate).isValid()) {
          setValidDates(true);
        } else {
          setValidDates(false);
        }
      }
      setPageLoader(false);
    } catch (ex) {
      console.error(ex);
      setPageLoader(false);
    }
  };

  const handleShowAmendmentHistory = async (appNo: string) => {
    if (!appNo) return;

    try {
      const amdresponse = await getAmendmentHistory(appNo);
      setAmendmentHistory(amdresponse);
      setShowAmendmentHistory(true);
    } catch (error) {
      console.error("Error fetching amendment history:", error);
    }
  };

  useEffect(() => {
    getMaster();
  }, []);
  useEffect(() => {
    if (IsSubmitresultRequest || IsAcknowledge) {
      setActiveTab(4);
    }
  }, [IsSubmitresultRequest, IsAcknowledge]);

  const handledFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files) {
      let filesArray = Array.from(event.target.files);
      let documentsArray: { ID: string; Name: string; Attachment: string }[] =
        [];

      for (let file of filesArray) {
        const base64String = await fileToBase64(file);
        if (base64String.length) {
          documentsArray.push({
            ID: "",
            Name: file.name,
            Attachment: base64String,
          });
        }
      }

      if (documentsArray.length) {
        setPreference((prevState) => {
          return {
            ...prevState,
            supportDocuments: [
              ...(prevState.supportDocuments || []),
              ...documentsArray,
            ],
            supportDocumentName: [
              ...(prevState.supportDocumentName
                ? prevState.supportDocumentName.split(", ")
                : []),
              ...documentsArray.map((doc) => doc.Name),
            ].join(", "),
          } as typeof Preference;
        });
      }
    }
  };

  const handleRemoveFile = (fileName: string) => {
    setPreference((prevState) => {
      const fileIndex = prevState.supportDocumentName
        ?.split(", ")
        .indexOf(fileName);
      if (fileIndex === -1) return prevState;
      const updatedSupportDocuments = prevState.supportDocuments?.filter(
        (_, index) => index !== fileIndex
      );
      const updatedSupportDocumentNames = prevState.supportDocumentName
        ?.split(", ")
        .filter((_, index) => index !== fileIndex)
        .join(", ");
      return {
        ...prevState,
        supportDocuments: updatedSupportDocuments,
        supportDocumentName: updatedSupportDocumentNames,
      };
    });
  };

  const fetchData = async (addressType: string) => {
    try {
      if (!postalCode.postalCode || addressType !== "Local") {
        return;
      }

      const encodedPostalCode = encodeURIComponent(postalCode.postalCode);
      const apiUrl = `https://www.onemap.gov.sg/api/common/elastic/search?searchVal=${encodedPostalCode}&returnGeom=N&getAddrDetails=Y&pageNum=1`;

      const response = await fetch(apiUrl);

      if (!response.ok) {
        console.error("Error:", response);
        return;
      }

      const data = await response.json();

      if (data.found > 0) {
        const result = data.results[0];

        setENVSampleDetails((prevDetails) => ({
          ...prevDetails,
          postalCode: postalCode.postalCode,
          streetName: result.ROAD_NAME,
          blockHouseNo: result.BLK_NO,
          buildingName: result.BUILDING,
        }));
      } else {
        setENVSampleDetails((prevDetails) => ({
          ...prevDetails,
          postalCode: postalCode.postalCode,
          streetName: "",
          blockHouseNo: "",
          buildingName: "",
        }));
      }
    } catch (error) {
      console.error("Error fetching data:", error);

      setENVSampleDetails((prevDetails) => ({
        ...prevDetails,
        postalCode: postalCode.postalCode,
        streetName: "",
        blockHouseNo: "",
        buildingName: "",
      }));
    }
  };
  const handleAddTestResult = (sampleIndex: number, testLabTestID: string) => {
    const newResult = { ...defaultTestResult };

    setSamplesAndTests((prevSamplesAndTests) => {
      const updatedSamplesAndTests = prevSamplesAndTests.map((sample) => {
        const updatedLabENVTestDetails = sample.labENVTestDetails.map(
          (test) => {
            if (test.labTestID === testLabTestID) {
              const updatedLabENVTestResult = [
                ...(test.labENVTestResult || []),
                newResult,
              ];

              return {
                ...test,
                labENVTestResult: updatedLabENVTestResult,
              };
            }
            return test;
          }
        );

        if (
          sample.labENVTestDetails.some(
            (test) => test.labTestID === testLabTestID
          )
        ) {
        }

        return {
          ...sample,
          labENVTestDetails: updatedLabENVTestDetails,
        };
      });

      return updatedSamplesAndTests;
    });
  };

  const handledCopyButtonClick = (
    sampleIndex: number,
    testLabTestID: string,
    resultIndex: number
  ) => {
    setSamplesAndTests((prevSamplesAndTests) => {
      const updatedSamplesAndTests = prevSamplesAndTests.map((sample) => {
        const updatedLabENVTestDetails = sample.labENVTestDetails.map(
          (test) => {
            if (test.labTestID === testLabTestID) {
              const labENVTestResult = Array.isArray(test.labENVTestResult)
                ? test.labENVTestResult
                : [];
              const valueToCopy = labENVTestResult[resultIndex]
                ? { ...labENVTestResult[resultIndex] }
                : defaultTestResult;

              const updatedLabENVTestResult = [
                ...labENVTestResult,
                valueToCopy,
              ];

              return {
                ...test,
                labENVTestResult: updatedLabENVTestResult,
              };
            }
            return test;
          }
        );

        if (
          sample.labENVTestDetails.some(
            (test) => test.labTestID === testLabTestID
          )
        ) {
        }

        return {
          ...sample,
          labENVTestDetails: updatedLabENVTestDetails,
        };
      });

      return updatedSamplesAndTests;
    });
  };

  let samplesAndTestSchema: IENVSamplesAndTests = {
    id: Date.now(),
    sampleMarking: "",
    species: "",
    longitude: "",
    latitude: "",
    breed: "",

    antibioticSensitivityTestRequired: false,
    specimenDescription: "",
    noOfSamples: 1,
    labENVTestDetails: [],
  };

  const [samplesAndTests, setSamplesAndTests] = useState<IENVSamplesAndTests[]>(
    [samplesAndTestSchema]
  );

  const handledSamplesAndTestsChange =
    (
      altIndex: number,
      type: string,
      testLabTestID: string,
      resultIndex: number
    ) =>
    (
      e: React.ChangeEvent<
        HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
      >
    ) => {
      let newValue: boolean | number | string | undefined;
      if (type === "decimal") {
        newValue = Math.max(0, parseFloat(e.target.value));
      } else if (type === "number") {
        newValue = Math.max(0, parseInt(e.target.value));
      } else if (type === "date") {
        newValue = moment(e.target.value, "YYYY-MM-DD").toISOString();
      } else {
        newValue = e.target.value;
      }

      setSamplesAndTests((prevSamples) => {
        const updatedSamples = prevSamples.map((item) => {
          const updatedLabENVTestDetails = item.labENVTestDetails.map(
            (test) => {
              if (test.labTestID === testLabTestID) {
                const updatedLabENVTestResult = (
                  test.labENVTestResult && test.labENVTestResult.length > 0
                    ? test.labENVTestResult
                    : [defaultTestResult]
                ).map((result, k) => {
                  if (k === resultIndex) {
                    return {
                      ...result,
                      [e.target.name]: newValue,
                    };
                  } else {
                    return result;
                  }
                });

                return {
                  ...test,
                  labENVTestResult: updatedLabENVTestResult,
                };
              } else {
                return test;
              }
            }
          );

          return {
            ...item,
            labENVTestDetails: updatedLabENVTestDetails,
          };
        });

        return updatedSamples;
      });
    };
  function getModifiedValues<T>(original: T, current: T): Partial<T> {
    const modified: Partial<T> = {};
    for (const key in current) {
      if (current[key] !== original[key]) {
        modified[key] = current[key];
      }
    }
    return modified;
  }
  function getModifiedPreference(
    original: IlabENVPreference,
    current: IlabENVPreference
  ): IlabENVPreference | undefined {
    const modified: Partial<IlabENVPreference> = {};

    for (const key in current) {
      if (
        JSON.stringify(original[key as keyof IlabENVPreference]) !==
        JSON.stringify(current[key as keyof IlabENVPreference])
      ) {
        modified[key as keyof IlabENVPreference] =
          current[key as keyof IlabENVPreference];
      }
    }
    if (Object.keys(modified).length === 0) {
      return undefined;
    }
    return modified as IlabENVPreference;
  }
  function getModifiedSamplesAndTests(
    original: IENVSamplesAndTests[],
    current: IENVSamplesAndTests[]
  ) {
    return current
      .map((currentItem, index) => {
        const originalItem = original[index];
        const modifiedItem: any = {};
        if (currentItem.sampleCaseRowId !== originalItem?.sampleCaseRowId) {
          modifiedItem.sampleCaseRowId = currentItem.sampleCaseRowId;
        }
        Object.keys(currentItem).forEach((key) => {
          const currentValue = currentItem[key];
          const originalValue = originalItem ? originalItem[key] : undefined;
          if (currentValue !== originalValue) {
            modifiedItem[key] = currentValue;
          }
        });
        return Object.keys(modifiedItem).length > 0 ? modifiedItem : null;
      })
      .filter((item) => item !== null);
  }

  const handledFiledChange = async (
    sampleIndex: number,
    testLabTestID: string,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files) {
      const files = Array.from(event.target.files);
      const base64Files = await Promise.all(
        files.map((file) => fileToBase64(file))
      );

      const newResultDocuments = base64Files.filter(
        (base64) => base64.length > 0
      );
      const newResultDocumentNames = files.map((file) => file.name);

      setSamplesAndTests((prevState) => {
        const updatedSamples = prevState.map((sample, sIndex) => {
          const updatedLabENVTestDetail = sample.labENVTestDetails.map(
            (test) => {
              if (test.labTestID === testLabTestID) {
                const updatedResultDocuments = [
                  ...(test.ResultDocuments || []),
                  ...newResultDocuments,
                ];
                const updatedResultDocumentNames = [
                  ...(test.ResultDocumentName
                    ? test.ResultDocumentName.split(", ")
                    : []),
                  ...newResultDocumentNames,
                ];

                return {
                  ...test,
                  ResultDocuments: updatedResultDocuments,
                  ResultDocumentName: updatedResultDocumentNames.join(", "),
                };
              }
              return test;
            }
          );

          return {
            ...sample,
            labENVTestDetails: updatedLabENVTestDetail,
          };
        });

        return updatedSamples;
      });
    }
  };

  const handleDeleteTestResult = (
    sampleIndex: number,
    testLabTestID: string,
    resultIndex: number
  ) => {
    setSamplesAndTests((prevSamples) => {
      const updatedSamples = prevSamples.map((item) => {
        const updatedLabENVTestDetails = item.labENVTestDetails.map((test) => {
          if (test.labTestID === testLabTestID) {
            const updatedLabENVTestResult = test.labENVTestResult
              ? test.labENVTestResult.filter((_, k) => k !== resultIndex)
              : [];

            if (updatedLabENVTestResult.length === 0) {
              updatedLabENVTestResult.push(defaultTestResult);
            }

            return {
              ...test,
              labENVTestResult: updatedLabENVTestResult,
            };
          } else {
            return test;
          }
        });

        return {
          ...item,
          labENVTestDetails: updatedLabENVTestDetails,
        };
      });

      return updatedSamples;
    });
  };

  const validateSamplesAndTests = (
    samplesAndTests: any[],
    customerNRIC: string
  ) => {
    let isValidSampleAndTests = true;
    let missingFields: string[] = [];

    const validatedSamples = samplesAndTests.map((item: any) => {
      const filteredTests =
        item.labENVTestDetails?.filter((test: any) => {
          const isValidTest =
            test.isThirdPartyLab === 1 &&
            test.thirdPartyNric === customerNRIC &&
            test.rowId === testRowId &&
            (test.testStatus === null || test.testStatus !== 8);
          return isValidTest;
        }) || [];

      filteredTests.forEach((test: any) => {
        const isPostMartem = test.isPostMartem === 1;

        const fieldsToValidate = isPostMartem
          ? postMartemFields
          : Object.values(ResultMandatoryFields);

        if (test.labENVTestResult && test.labENVTestResult.length > 0) {
          test.labENVTestResult = test.labENVTestResult.map(
            (result: any, resultIndex: number) => {
              let isValidResult = true;

              fieldsToValidate.forEach((field) => {
                const fieldValue = result[field];

                if (
                  fieldValue === undefined ||
                  fieldValue === null ||
                  fieldValue === ""
                ) {
                  isValidSampleAndTests = false;
                  isValidResult = false;
                  missingFields.push(field);

                  result = {
                    ...result,
                    [`${field}ErrMsg`]: `Please fill ${field}.`,
                  };
                } else {
                  result = {
                    ...result,
                    [`${field}ErrMsg`]: "",
                  };
                }
              });

              return result;
            }
          );
        }
      });

      return item;
    });

    return { isValidSampleAndTests, validatedSamples, missingFields };
  };
  const handledSaveResultClick = async () => {
    try {
      handleLoader(true, "submit-req");

      const { isValidSampleAndTests, validatedSamples, missingFields } =
        validateSamplesAndTests(samplesAndTests, customerNRIC);

      if (!isValidSampleAndTests) {
        setSamplesAndTests(validatedSamples);
        message(NotifyType.Error, "Please fill the mandatory fields.");
        handleLoader(false, "");
        return;
      }

      const applicationNum = params.get("an") ?? "";
      const dataToSubmit = {
        applicationNumber: applicationNum,
        labResultRequests: samplesAndTests.flatMap((sample) =>
          sample.labENVTestDetails
            .filter((test) => {
              const isValidTest =
                test.isThirdPartyLab === 1 &&
                test.thirdPartyNric === customerNRIC &&
                test.rowId === testRowId &&
                (test.testStatus === null || test.testStatus !== 8);

              return test.testDescription !== "" && isValidTest;
            })
            .flatMap((test) =>
              (test.labENVTestResult ?? []).map((result, resultIndex) => ({
                labTestID: test.labTestID,
                testDescription: stripHtmlTags(test.testDescription),
                ResultDocuments: test.ResultDocuments ?? [],
                ResultDocumentName: test.ResultDocumentName ?? "",
                isAdditionalResult: resultIndex === 0 ? 0 : 1,
                ...mergeWithDefaults(result),
              }))
            )
        ),
      };

      const response = await saveResultRequest(dataToSubmit);
      if (response?.status === 200) {
        message(NotifyType.Success, "Results Saved Successfully");
        localStorage.removeItem("psh-app-applicationNum");
        localStorage.removeItem("psh-app-status");
        localStorage.removeItem("ismetadata");
        setTimeout(() => {
          navigate("/");
        }, 3000);
      } else {
        message(NotifyType.Error, "Issue on the request submission.");
      }
    } catch (error) {
      console.error(ErrMsg.InternalServerErrMsg, error);
      message(NotifyType.Error, ErrMsg.InternalServerErrMsg);
    } finally {
      handleLoader(false, "");
    }
  };

  const handleACKResultClick = async () => {
    try {
      handleLoader(true, "submit-req");
      const newArray = samplesAndTests.map((sample: any) => {
        sample.labENVTestDetails.forEach((test: any) => {
          delete test.labENVTestResult;
        });
        return sample;
      });
      setSamplesAndTests(newArray);
      const applicationNum = params.get("an") ?? "";
      const dataToSubmit = {
        applicationNumber: applicationNum,
        labResultRequests: samplesAndTests.flatMap((sample) =>
          sample.labENVTestDetails
            .filter(
              (test) =>
                test.testDescription !== "" &&
                test.isThirdPartyLab === 1 &&
                test.thirdPartyNric === customerNRIC &&
                test.rowId === testRowId &&
                test.testStatus !== 8
            )
            .map((test) => ({
              labTestID: test.labTestID,
              testDescription: test.testDescription,
              laboratory: test.laboratory,
              TestStatus: 7,
            }))
        ),
      };
      if (dataToSubmit.labResultRequests.length === 0) {
        message(NotifyType.Warning, "No tests available for submission.");
        return;
      }

      const response = await saveAckRequest(dataToSubmit);
      if (response?.status === 200) {
        message(NotifyType.Success, "Request Saved Successfully");
        localStorage.removeItem("psh-app-applicationNum");
        localStorage.removeItem("ismetadata");
        localStorage.removeItem("psh-app-status");
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set("type", "submitresult");
        window.location.href = currentUrl.toString();
      } else {
        message(NotifyType.Error, "Issue with the request submission.");
      }
    } catch (error) {
      console.error(ErrMsg.InternalServerErrMsg, error);
      message(NotifyType.Error, ErrMsg.InternalServerErrMsg);
    } finally {
      handleLoader(false, "");
    }
  };
  const handledPreviousClick = () => {
    navigate("/labresults-dashboard");
  };
  const handlePreviousClick = () => {
    if (IsAcknowledgeRequest || isCancelRequest || amendCase) {
      navigate("/lab-dashboard");
    } else {
      navigate("/choose-application");
    }
  };

  const handleShowSearchTestsModal = (index: number) => {
    setSearchInd(index);
    setShowSearchTestsModal(true);
  };

  const handleNextClick = async () => {
    storeInContext();
    try {
      await getENVRequestSchema();
      localStorage.removeItem("ismetadata");
      navigate("/env-review");
      handleLoader(true, "next-click");
      let borderDanger = document.getElementsByClassName("border-danger");
      if (borderDanger.length > 0) {
        message(NotifyType.Error, "Please fill the mandatory fields.");
        handleLoader(false, "next-click");
        return;
      }

      handleLoader(false, "next-click");
    } catch (error) {
      console.error("Error:", error);
      handleLoader(false, "next-click");
    }
  };

  const handleSamplesAndTestsChange =
    (
      index: number,
      type: "number" | "string" | "date" | "datetime" | "boolean" | "checkbox"
    ) =>
    (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
      const target = e.target as HTMLInputElement;
      const newArray = samplesAndTests.map((item: IENVSamplesAndTests, i) => {
        if (index === i) {
          let value: string | number | boolean | Date = target.value;

          if (type === "number") {
            const numericValue = parseInt(target.value) || 1;
            value = Math.min(1000, Math.max(1, numericValue));
            if (target.type === "number") {
              target.value = value.toString();
            }
          } else if (type === "date") {
            value = moment(value).startOf("day").format();
          } else if (type === "datetime") {
            value = moment(value).toISOString();
          } else if (type === "boolean" || type === "checkbox") {
            value = target.checked;
          }

          return {
            ...item,
            [target.name]: value,
          };
        } else {
          return item;
        }
      });

      setSamplesAndTests(newArray);
    };
  const generateRejectedTestsMessage = (samplesAndTests: any[]) => {
    let message = "Please be noted that the Test: ";
    let rejectedTests: string[] = [];

    samplesAndTests.forEach((sample: any, sampleIndex: number) => {
      const sampleMarking = sample.sampleMarking;
      sample.labENVTestDetails.forEach((test: any) => {
        if (test.testStatus === 6) {
          rejectedTests.push(
            `${test.testDescription} under Sample ${
              sampleIndex + 1
            } (${sampleMarking})`
          );
        }
      });
    });

    if (rejectedTests.length > 0) {
      message += rejectedTests.join(", ") + " is/are Rejected.";
    } else {
      message = "";
    }

    return message;
  };

  useEffect(() => {
    async function checkQueryString() {
      setcheckPageLoader(true);
      const applicationNum: string | null = params.get("an");
      const getUserInfo = localStorage.getItem("app-data");
      const isMetadata = localStorage.getItem("ismetadata");
      const userInfo = JSON.parse(getUserInfo || "");
      let NRIC = userInfo?.user?.idNo || "";
      const actionType: string | null = params.get("type");
      setActionType(actionType || "");
      setApplicationNum(applicationNum || "");
      let isNricRequired = 1;
      if (
        actionType === TypeOfApplicationEnum.submitresult ||
        actionType === TypeOfApplicationEnum.Acknowledge
      ) {
        isNricRequired = 0;
      }

      try {
        if (applicationNum && actionType) {
          const getENV = await getENVApplication(
            applicationNum,
            NRIC,
            isNricRequired
          );
          if (getENV.status === 200) {
            setShowPlaceholder(false);
            let result: IENVRequest = getENV.data.result;
            if (result?.labENVApplicationDetails) {
              const fromDate = result.labENVApplicationDetails.samplingFromDate;
              const toDate = result.labENVApplicationDetails.samplingToDate;

              if (moment(fromDate).isValid() && moment(toDate).isValid()) {
                setValidDates(true);
              } else {
                setValidDates(false);
              }
            }
            const feedback = result?.submittedFeedback || 0;
            const reportgenerated = result?.isReportGenerated || 0;
            const reports = Array.isArray(result?.labReportDetails)
              ? result.labReportDetails
              : [];
            setReports(reports);
            setSubmittedFeedback(feedback);
            setreportgenerated(reportgenerated);
            if (isMetadata !== "1") {
              setENVSampleDetails(result?.labENVApplicationDetails);
              setOriginalSampleDetails(result?.labENVApplicationDetails);
              setPreference(result?.labENVPreference);
              setOriginalPreference(result?.labENVPreference);
              const personalInfoDetails = result?.labENVPersonalInfoDetails;
              setPersonalInfo(personalInfoDetails);

              if (result?.labENVPersonalInfoDetails?.contact) {
                setCustomerName(result.labENVPersonalInfoDetails.customerName);
                setSalutation(
                  result.labENVPersonalInfoDetails.contact.salutation
                );
              }
            }
            if (result?.labENVSampleTests?.length > 0) {
              localStorage.setItem(
                "choose-app",
                JSON.stringify(result.labENVChooseApplDetails)
              );
              const actionedStatus = result?.actionStatus;
              if (actionedStatus) {
                localStorage.setItem("psh-app-status", actionedStatus);
                localStorage.setItem("psh-app-applicationNum", applicationNum);
              }

              if (
                actionType == TypeOfApplicationEnum.amendment &&
                result?.actionStatus
              ) {
                let amendCase = "";
                if (result.actionStatus === "Pending Sample(s)") {
                  amendCase = "CASE3";
                } else {
                  amendCase = "CASE4";
                }

                setAmendCase(amendCase);
              } else if (actionType == TypeOfApplicationEnum.cancel) {
                setIsCancelRequest(true);
              } else if (actionType === TypeOfApplicationEnum.submitresult) {
                setIsSubmitresultRequest(true);
              } else if (actionType === TypeOfApplicationEnum.Acknowledge) {
                setIsAcknowledge(true);
              } else if (actionType == TypeOfApplicationEnum.acknowledgement) {
                setIsAcknowledgeRequest(true);
              }

              const appNo = params.get("an") ?? "";
              if(appNo && result?.labENVChooseApplDetails?.applicationType == ApplicationTypeEnum.amendment)
              {            
                handleShowAmendmentHistory(appNo);
                setShowAmendmentHistory(true);            
              }

              let samplesAndTests = result.labENVSampleTests.map(
                (sample, index) => {
                  const postmartem = sample.labENVTestDetails.map(
                    (obj: any) => ({
                      isPostMartem: obj.isPostMartem,
                      labTestID: obj.labTestID,
                      testStatus: obj.testStatus,
                      nooftestsrequired: obj.nooftestsrequired,
                      noOfSamples: obj.noOfSamples,
                      disableDelete: true,
                      rowId: obj.rowId,
                      isThirdPartyLab: obj.isThirdPartyLab,
                      thirdPartyNric: obj.thirdPartyNric,
                      testDescription: obj.description || obj.testDescription,
                      labENVTestResult: [defaultTestResult],
                    })
                  );

                  if (postmartem.length > 0) {
                    setIsPostMartem(postmartem[0].isPostMartem);
                    setlabTestID(postmartem[0].labTestID);
                    setTestStatus(postmartem[0].testStatus);
                    setisThirdPartyLab(postmartem[0].isThirdPartyLab);
                    setthirdPartyNric(postmartem[0].thirdPartyNric);
                  }
                  return {
                    ...sample,
                    id: sample.id || index + 1,
                    sampleCaseRowId: sample.rowId,
                    disableDelete: true,
                    labENVTestDetails: postmartem,
                  };
                }
              );

              if (isMetadata !== "1") {
                setSamplesAndTests(samplesAndTests);
                setOriginalSamplesAndTests(samplesAndTests);
              }
              await Promise.all(samplesAndTests);
              setRejectedTestsMessage(
                generateRejectedTestsMessage(samplesAndTests)
              );
            }
          }
        }
      } catch (error) {
        console.error(ErrMsg.InternalServerErrMsg, error);
        message(NotifyType.Error, ErrMsg.InternalServerErrMsg);
      } finally {
        setcheckPageLoader(false);
        localStorage.removeItem("ismetadata");
      }
    }
    if (!hasFetchedInitialData) {
      checkQueryString();
      setHasFetchedInitialData(true);
    }
  }, [clinicalHistoryOptions, hasFetchedInitialData]);
  useEffect(() => {
    if (ENVSampleDetails?.farmCode) {
      const fetchPremiseDetails = async () => {
        try {
          const response = await PremiseCodeDetails(ENVSampleDetails?.farmCode);

          setENVSampleDetails((prevDetails) => ({
            ...prevDetails,
            postalCode: response.data.postalCode || "",
            streetName: response.data.streetRoadName || "",
            blockHouseNo: response.data.blockHouseNumber || "",
            buildingName: response.data.buildingName || "",
            country: response.data.country || "",
            level: response.data.floorNumber || "",
            unitNo: response.data.unitNumber || "",
            cityName: response.data.districtCity || "",
            state: response.data.stateProvince || "",
            locationName: response.data.premisesName || "",
            addressType:
              response.data.country === "Singapore" ? "Local" : "Foreign",
          }));
        } catch (error) {
          console.error("Failed to fetch premise details", error);
        }
      };

      fetchPremiseDetails();
    } else {
      setENVSampleDetails((prevDetails) => ({
        ...prevDetails,
        postalCode: "",
        streetName: "",
        blockHouseNo: "",
        buildingName: "",
        country: "",
        locationName: "",
      }));
    }
  }, [ENVSampleDetails?.farmCode]);
  const handleENVSampleDetails = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
    type: string
  ) => {
    let name = e.target.name;
    let value: any = e.target.value;

    if (type === "radio") {
      if ((e.target as HTMLInputElement).checked) {
        setAddressType(value);
        if (name === "addressType" && value === "Local") {
          fetchData(value);
          setENVSampleDetails((prevState) => ({
            ...prevState,
            [name]: value,
            country: "Singapore",
          }));
          return;
        } else if (name === "addressType" && value === "Foreign") {
          setENVSampleDetails((prevState) => ({
            ...prevState,
            [name]: value,
            country: "",
            postalCode: "",
            blockHouseNo: "",
            streetName: "",
            level: "",
            unitNo: "",
            buildingName: "",
            cityName: "",
            state: "",
          }));
          return;
        }
      }
    } else if (type === "checkbox") {
      value = (e.target as HTMLInputElement).checked;
    } else {
      value = e.target.value;

      if (type === "number") {
        value = parseInt(value);
      } else if (type === "date") {
        value = moment(value).startOf("day").format();
      } else if (type === "datetime") {
        value = moment(value).toISOString();
      }
    }

    setENVSampleDetails((prevState) => {
      const newDetails = {
        ...prevState,
        [name]: value,
      } as IENVSampleDetails;

      let validDates = true;

      if (newDetails.samplingFromDate && newDetails.samplingToDate) {
        const fromDate = moment(newDetails.samplingFromDate);
        const toDate = moment(newDetails.samplingToDate);

        if (toDate.isBefore(fromDate)) {
          newDetails.samplingToDateErrMsg =
            "Sampling To Date must be after Sampling From Date";
          validDates = false;
        } else {
          newDetails.samplingToDateErrMsg = undefined;
        }
        if (fromDate.isAfter(toDate)) {
          newDetails.samplingFromDateErrMsg =
            "Sampling From Date must be before Sampling To Date";
          validDates = false;
        } else {
          newDetails.samplingFromDateErrMsg = undefined;
        }
      }

      setValidDates(validDates);
      setRedMessage("");
      if (ENVSampleDetails?.purposeTestErrMsg) {
        ENVSampleDetails.purposeTestErrMsg = "";
      }
      return newDetails;
    });
  };

  const handleAddTests = () => {
    const testsToAdd = testOptions.filter(
      (test) =>
        test?.labCodeMasterID &&
        selectedTestIds.includes(test.labCodeMasterID as any)
    );

    setTestOptions((prevOptions) =>
      prevOptions.filter(
        (test) => !selectedTestIds.includes(test.labCodeMasterID as any)
      )
    );

    setSelectedTestIds([]);

    setSamplesAndTests((prevSamples: any) => {
      return prevSamples.map((prevSample: any, index: number) => {
        if (index === searchInd) {
          const currentTestDetails = prevSample.labENVTestDetails || [];
          const addedTests = currentTestDetails.map((detail: any) =>
            strippedHtmlTags(detail.testDescription)
          );
          testsToAdd.forEach((test) => {
            const strippedTestDescription = strippedHtmlTags(test.description);
            if (!addedTests.includes(strippedTestDescription)) {
              currentTestDetails.push({
                testDescription: test.description.trim(),
                laboratory: selectedTestLaboratory,
                nooftestsrequired: 1,
                noOfSamples: 1,
              });
            }
          });

          return {
            ...prevSample,
            labENVTestDetails: currentTestDetails,
          };
        } else {
          return prevSample;
        }
      });
    });
  };

  const handleRemoveTest = (
    labDetails: any,
    description: string,
    ind: number
  ) => {
    let removeTheLabID = labDetails.filter(
      (x: ILabTestDetails) => x.testDescription != description
    );
    const newArray = samplesAndTests.map((item: IENVSamplesAndTests, i) => {
      if (ind === i) {
        return {
          ...item,
          labENVTestDetails: removeTheLabID,
        };
      } else {
        return item;
      }
    });
    setSamplesAndTests(newArray);
  };

  useEffect(() => {}, [testOptions]);
  const handleSamplesCountChange = (
    sampleIndex: number,
    testIndex: number,
    count: number
  ) => {
    const validatedCount = count < 1 ? 1 : count;

    setSamplesAndTests((prevSamples) => {
      return prevSamples.map((sample, sIndex) => {
        if (sIndex === sampleIndex) {
          const updatedLabENVTestDetails = sample.labENVTestDetails.map(
            (test, tIndex) => {
              if (tIndex === testIndex) {
                return {
                  ...test,
                  noOfSamples: validatedCount,
                };
              }
              return test;
            }
          );
          return {
            ...sample,
            labENVTestDetails: updatedLabENVTestDetails,
          };
        }
        return sample;
      });
    });
  };

  const handleRepeatCountChange = (
    sampleIndex: number,
    testIndex: number,
    count: number
  ) => {
    const validatedCount = count < 1 ? 1 : count;

    setRepeatCounts((prev) => ({
      ...prev,
      [sampleIndex]: {
        ...(prev[sampleIndex] || {}),
        [testIndex]: validatedCount,
      },
    }));

    setSamplesAndTests((prevSamples) => {
      return prevSamples.map((sample, sIndex) => {
        if (sIndex === sampleIndex) {
          const updatedLabENVTestDetails = sample.labENVTestDetails.map(
            (test, tIndex) => {
              if (tIndex === testIndex) {
                return {
                  ...test,
                  nooftestsrequired: validatedCount,
                };
              }
              return test;
            }
          );
          return {
            ...sample,
            labENVTestDetails: updatedLabENVTestDetails,
          };
        }
        return sample;
      });
    });
  };

  const toggleTestSelection = (
    labCodeMasterID: string | undefined,
    isChecked: boolean
  ) => {
    setTestOptions((prevOptions) =>
      prevOptions.map((test) =>
        test.labCodeMasterID === labCodeMasterID
          ? { ...test, isSelected: isChecked }
          : test
      )
    );

    setSelectedTestIds((prevSelected: any) => {
      if (isChecked) {
        return [...prevSelected, labCodeMasterID as string];
      } else {
        return prevSelected.filter((id: any) => id !== labCodeMasterID);
      }
    });
  };
  const handleSearch = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    fetchTestCodeMaster();
  };
  const fetchTestCodeMaster = async () => {
    try {
      handleLoader(true, "submit-reqq");
      const response: any = await getPshCavsTestCodeMaster({
        PurposeCode: "ENV",
        IsBiosurvillanceUser: IsBiosurvillanceUser,
      });

      if (response.data && response.data.cavs) {
        const selectedLabTitle = selectedTestLaboratory;
        let searchString: string = testDescription || "";
        const cavsData = response.data.cavs;
        const stripHtmlTags = (str: string) => {
          return str.replace(/<\/?[^>]+(>|$)/g, "");
        };

        const formatDescription = (description: string) => {
          return description.replace(/<i>/g, "<em>").replace(/<\/i>/g, "</em>");
        };
        if (selectedLabTitle === "All-laboratories") {
          const filteredData = cavsData.filter((item: any) =>
            item.description
              ? stripHtmlTags(item.description)
                  .toLowerCase()
                  .includes(searchString.toLowerCase())
              : false
          );

          const transformedData = filteredData.map((item: any) => ({
            description: formatDescription(item.description),
            labGroupId: item.labGroupId,
            labGroup: item.labGroup,
            labCodeMasterID: item.labCodeMasterID,
          }));
          setTestOptions(transformedData);
        } else {
          const labGroupId = labtestoptions.find(
            (item: any) => item.labGroup === selectedLabTitle
          )?.labGroupId;

          if (!labGroupId) {
            console.error(
              "Lab Master ID not found for the selected laboratory labGroup:",
              selectedLabTitle
            );
            return;
          }

          const customFilter = cavsData.filter(
            (x: any) =>
              x.labGroupId === labGroupId &&
              (x.name
                ? stripHtmlTags(x.name)
                    .toLowerCase()
                    .includes(searchString.toLowerCase())
                : false)
          );

          const transformedData = customFilter.map((item: any) => ({
            description: formatDescription(item.description),
            labGroupId: item.labGroupId,
            labGroup: item.labGroup,
            labCodeMasterID: item.labCodeMasterID,
          }));
          setTestOptions(transformedData);
        }
      } else {
        const errorMessage = "Failed to retrieve the CAVS data from the API";
        console.log(errorMessage);
        setErrorMessage(errorMessage);
      }
    } catch (error) {
      console.error("Error fetching test code master data:", error);
    } finally {
      handleLoader(false, "submit-reqq");
    }
  };

  const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleSearch(e as unknown as React.MouseEvent<HTMLButtonElement>);
  };

  const handleCloseSearchTestsModal = () => {
    setShowSearchTestsModal(false);
  };

  const handleToggleFarmDetails = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    setShowFarmDetails((prevShowFarmDetails) => !prevShowFarmDetails);
  };
  const handleAddSample = () => {
    setSamplesAndTests((prevSamples) => {
      const newSample = {
        ...samplesAndTestSchema,
        id: Date.now(),
        labENVTestDetails: [],
      };
      return [...prevSamples, newSample];
    });
  };

  const handleDeleteSample = (sampleId: number | undefined) => {
    setSamplesAndTests((samples) => {
      if (samples.length > 1) {
        return samples.filter((sample) => sample.id !== sampleId);
      }
      return samples;
    });
  };

  const handleCopySample = (sampleInd: number, times: number) => {
    const sample = samplesAndTests[sampleInd];

    setSamplesAndTests((prevSamples) => {
      const newSamples = Array.from({ length: times }, () => {
        const newSample = {
          ...sample,
          id: Date.now() + Math.random(),
          disableDelete: false,
          labENVTestDetails: sample?.labENVTestDetails?.map((obj: any) => ({
            ...obj,
            disableDelete: false,
          })),
        };
        if (newSample.hasOwnProperty("rowId")) {
          delete newSample.rowId;
        }

        return newSample;
      });

      return [...prevSamples, ...newSamples];
    });
  };
  const handleCopyButtonClick = (index: number) => {
    handleCopySample(index, copyCount || 1);
  };

  const handleCopyInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setCopyCount(Number(event.target.value));
  };

  const handleSaveDraftClick = async () => {
    delete ENVSampleDetails?.samplesCollectedOrSubmittedErrMsg;
    delete ENVSampleDetails?.purposeTestErrMsg;
    delete ENVSampleDetails?.otherPurposeOfTestErrMsg;
    delete ENVSampleDetails?.samplingFromDateErrMsg;
    delete ENVSampleDetails?.samplingToDateErrMsg;
    delete ENVSampleDetails?.sampledByErrMsg;
    try {
      handleLoader(true, "submit-req");
      const hasEmptyTests = samplesAndTests.some(
        (sample) =>
          !sample.labENVTestDetails || sample.labENVTestDetails.length === 0
      );

      if (hasEmptyTests) {
        message(NotifyType.Error, "Please add Test Information.");
        handleLoader(false, "submit-req");
        return;
      }
      let chooseAppMeta: IChooseApp = {
        typeOfApplication: "ENV",
        typeOfService: "CAVS Laboratory Services",
        applicationType: 0
      };
      let personalInfo: IPersonalInfo = JSON.parse(
        localStorage.getItem("profile-info") || ""
      );

      const filerInfo: IFilerInformation | null = getFilerInfomation();
      const meta: IENVRequest = {
        labENVPersonalInfoDetails: personalInfo,
        labENVChooseApplDetails: chooseAppMeta,
        labENVApplicationDetails: {
          ...ENVSampleDetails,
        } as IENVSampleDetails,

        labENVSampleTests: samplesAndTests.map((sample) => {
          return {
            ...sample,
            labENVTestDetails: sample.labENVTestDetails.map((test: any) => ({
              ...test,
              testDescription: stripHtmlTags(test.testDescription),
            })),
          };
        }),
        labENVPreference: Preference,
        applicationNumber: applicationNum,
        labENVFilerInfoDetails: filerInfo || tempFilerInfo,
      };

      if (actionType === TypeOfApplicationEnum.submit) {
        delete meta.applicationNumber;
      }

      const response1 = await SaveENVDraftApplications(meta);

      if (response1.status === 200) {
        const acknowledgmentNumberMatch = response1.data?.match(
          /"ENVDraftApplicationNumber":"(\w+)"/
        );

        const acknowledgmentNumber = acknowledgmentNumberMatch
          ? acknowledgmentNumberMatch[1]
          : undefined;
        setApplicationNum(acknowledgmentNumber || "");
        if (actionType === TypeOfApplicationEnum.submit) {
          setActionType("Draft");
        }

        message(
          NotifyType.Success,
          acknowledgmentNumber
            ? `Draft Saved Successfully`
            : "Draft Saved Successfully"
        );

        setAcknowledgmentMessage(
          acknowledgmentNumber ? `${acknowledgmentNumber}` : ""
        );

        localStorage.removeItem("psh-app-status");
        localStorage.removeItem("ismetadata");
      } else {
        message(NotifyType.Error, "Issue on the request submission.");
        handleLoader(false, "submit-req");
      }
    } catch (error) {
      console.error(ErrMsg.InternalServerErrMsg, error);
      message(NotifyType.Error, ErrMsg.InternalServerErrMsg);
    } finally {
      handleLoader(false, "");
    }
  };

  const cancelRequest = async () => {
    delete ENVSampleDetails?.samplesCollectedOrSubmittedErrMsg;
    delete ENVSampleDetails?.purposeTestErrMsg;
    delete ENVSampleDetails?.otherPurposeOfTestErrMsg;
    delete ENVSampleDetails?.samplingFromDateErrMsg;
    delete ENVSampleDetails?.samplingToDateErrMsg;
    delete ENVSampleDetails?.sampledByErrMsg;
    try {
      setCancelCommentsErrMsg("");
      if (cancelComments) {
        handleLoader(true, "cancel-request-btn");

        let chooseAppMeta: IChooseApp = {
          typeOfApplication: "ENV",
          typeOfService: "CAVS Laboratory Services",
          applicationType: 0
        };

        let personalInfo: IPersonalInfo = JSON.parse(
          localStorage.getItem("profile-info") || ""
        );
        const applicationNum: string = params.get("an") ?? "";
        const filerInfo: IFilerInformation | null = getFilerInfomation();

        const meta: IENVRequest = {
          labENVPersonalInfoDetails: personalInfo,
          labENVChooseApplDetails: chooseAppMeta,
          labENVApplicationDetails: {
            ...ENVSampleDetails,
          } as IENVSampleDetails,
          labENVSampleTests: samplesAndTests,
          applicationNumber: applicationNum,
          labENVApplicationStatus: defENVCancelAppStatus,
          labENVPreference: Preference,
          labENVFilerInfoDetails: filerInfo || tempFilerInfo,
        };

        let response1 = await saveENVCancellation(meta);
        if (response1.status === 200) {
          const acknowledgmentNumberMatch = response1.data?.match(
            /"CAVS_AQUACancelApplicationNumber":"(\w+)"/
          );

          const acknowledgmentNumber = acknowledgmentNumberMatch
            ? acknowledgmentNumberMatch[1]
            : undefined;

          message(
            NotifyType.Success,
            `Cancellation Request Submitted Successfully. Acknowledgment Number: ${acknowledgmentNumber}`
          );

          setcancelMessage(
            acknowledgmentNumber ? `${acknowledgmentNumber}` : ""
          );

          localStorage.removeItem("choose-app");
          setCancelButtonHidden(true);
          setTimeout(() => {
            navigate("/lab-dashboard", { state: { acknowledgmentNumber } });
          }, 3000);
        } else {
          message(NotifyType.Error, "Issue on the request submission.");
        }
      } else {
        setCancelCommentsErrMsg("Please fill Cancellation Comments");
        message(NotifyType.Error, "Please fill the mandatory fields.");
      }
      handleLoader(false, "cancel-request-btn");
    } catch (ex) {
      console.error(ex);
      handleLoader(false, "cancel-request-btn");
    }
  };

  let bannerName = "Application for Laboratory Testing";
  if (isCancelRequest) {
    bannerName = "Submission of Cancellation Request";
  } else if (amendCase) {
    bannerName = "Submission of Amendment Request";
  } else if (IsAcknowledge) {
    bannerName = "Acknowledge Test";
  } else if (IsSubmitresultRequest) {
    bannerName = "Submission of Test Result";
  }
  return (
    <>
      <Header />
      <Container>
        <div className="h1Lab">{bannerName} </div>
        <Stepwizard
          currentStep={stepWizardConfig.currentStep}
          steps={stepWizardConfig.steps}
        />
        {pageLoader || checkpageLoader ? (
          <Loader />
        ) : (
          <div className="row setup-content" id="step-1">
            <div className="col-md-12">
              <div className="tab-wizard-content">
                {acknowledgmentMessage && (
                  <div className="info-content">
                    <div className="att">
                      <h3>Attention</h3>
                      <br />
                      <p className="attention">
                        {">"} Application has been successfully Saved as Draft.
                        Service Acknowledgement Number: &nbsp;
                        {acknowledgmentNumber ? acknowledgmentNumber : ""}
                      </p>
                      {acknowledgmentMessage}
                    </div>
                  </div>
                )}

                {RedMessage && (
                  <div className="info-content">
                    <div className="att">
                      <br />
                      <div className="text-danger">
                        <center>{RedMessage}</center>
                      </div>
                    </div>
                  </div>
                )}

                {cancelMessage && (
                  <div className="info-content">
                    <div className="att">
                      <h3>Attention</h3>
                      <br />
                      <p className="attention">
                        {">"} Cancellation Request Submitted Successfully.
                        Service Acknowledgement Number: &nbsp;
                        {cancelMessage ? cancelMessage : ""}
                      </p>
                    </div>
                  </div>
                )}
                {applicationNum && !cancelMessage && (
                  <div className="info-content">
                    <div className="att">
                      <h2>
                        <center>Application Number: {applicationNum}</center>
                      </h2>
                    </div>
                  </div>
                )}
                {!IsSubmitresultRequest && !IsAcknowledge ? (
                  <PersonalInformation
                    profileInfo={personalInfo}
                    onModeOfPaymentChange={setModeOfPayment}
                  />
                ) : null}

                {IsAcknowledgeRequest ? (
                  <div className="personal-info">
                    <div className="clonable-block" data-toggle="cloner">
                      <div className="clonable" data-clone-number="1">
                        <div className="info-heading">
                          <table className="table table-bordered table-hover">
                            <thead>
                              <tr>
                                <th className="grid-header">Report Name</th>
                                <th className="grid-header">Report Type</th>
                                <th className="grid-header">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {reports
                                .filter((report) => {
                                  const actionedStatus =
                                    localStorage.getItem("psh-app-status");
                                  if (report.reportData === null) return false;
                                  if (report.reportType === 5) {
                                    return (
                                      actionedStatus !== "Pending Sample(s)" &&
                                      actionedStatus !== "Sample(s) Received"
                                    );
                                  }
                                  return report.reportType === 3;
                                })
                                .map((report, index) => (
                                  <tr key={report.reportName}>
                                    <td>
                                      <center>
                                        <h6>{report.reportName}</h6>
                                      </center>
                                    </td>
                                    <td>
                                      <h6>
                                        {renderReportType(report.reportType)}
                                      </h6>
                                    </td>
                                    <td>
                                      <button
                                        className="ACKFile"
                                        onClick={() =>
                                          handleDownload(
                                            report.reportName,
                                            report.reportData,
                                            index,
                                            reports.length,
                                            applicationNum 
                                          )
                                        }
                                      >
                                        Download
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}

                <div className="info-content">
                  <div className="attt">
                    <h2>
                      <center>
                        <h2>Purpose Code: ENV</h2>
                      </center>
                    </h2>
                  </div>
                </div>

                <Tabs
                  className="samples-and-tests-cavs"
                  activeKey={activeTab.toString()}
                  onSelect={(k: string | null) => {
                    if (k) {
                      setActiveTab(parseInt(k));
                    }
                  }}
                  id="controlled-tab-example"
                >
                  {!(IsAcknowledge || IsSubmitresultRequest) && (
                    <Tab eventKey={1} title="Sample Details">
                      {pageLoader || checkpageLoader ? (
                        <Loader />
                      ) : (
                        <div className="personal-info">
                          <div className="info-heading">
                            <h2 className="pb-0">Sample Details</h2>
                          </div>
                          <div className="info-content">
                            <div className="row-mt-2">
                              <div className="row">
                                <div className="col-lg-12">
                                  <div className="row align-items-center">
                                    <div className="col-lg-3">
                                      <label
                                        className="form-check-label"
                                        htmlFor=""
                                      >
                                        Purpose of Application
                                        <span className="star-red">*</span>
                                      </label>
                                    </div>
                                    <div className="col-lg-3">
                                      <select
                                        className={`form-select ${
                                          ENVSampleDetails?.purposeTestErrMsg
                                            ? "border-danger op05"
                                            : ""
                                        }`}
                                        aria-label="Default select example"
                                        name="purposeTest"
                                        onChange={(e) =>
                                          handleENVSampleDetails(e, "number")
                                        }
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest ||
                                          modeOfPayment === "Biosurveillance"
                                        }
                                        value={
                                          modeOfPayment === "Biosurveillance"
                                            ? 1
                                            : ENVSampleDetails?.purposeTest
                                        }
                                      >
                                        <option selected>-- Select --</option>
                                        {purposeOfTestOptions &&
                                          purposeOfTestOptions
                                            .filter((x) =>
                                              modeOfPayment ===
                                              "Biosurveillance"
                                                ? x.id === 1
                                                : x.name !== "Biosurveillance"
                                            )
                                            .map((x) => (
                                              <option key={x.id} value={x.id}>
                                                {x.name}
                                              </option>
                                            ))}
                                      </select>
                                      {ENVSampleDetails?.purposeTestErrMsg && (
                                        <div className="error-message">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          Please fill Purpose of Application.
                                        </div>
                                      )}
                                      {ENVSampleDetails?.purposeTest === 7 && (
                                        <div className="mt-2">
                                          <input
                                            type="text"
                                            className={`form-control ${
                                              !ENVSampleDetails?.otherPurposeOfTest
                                                ? "border-danger op05"
                                                : ""
                                            }`}
                                            placeholder={
                                              showPlaceholder
                                                ? "Enter Purpose of Application"
                                                : ""
                                            }
                                            name="otherPurposeOfTest"
                                            value={
                                              ENVSampleDetails?.otherPurposeOfTest
                                            }
                                            maxLength={100}
                                            onChange={(e) =>
                                              handleENVSampleDetails(
                                                e,
                                                "string"
                                              )
                                            }
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                          />
                                          {ENVSampleDetails?.otherPurposeOfTestErrMsg && (
                                            <div className="error-message">
                                              <FontAwesomeIcon
                                                className="me-1"
                                                icon={faCircleExclamation}
                                              />
                                              {
                                                ENVSampleDetails.otherPurposeOfTestErrMsg
                                              }
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                    <div className="col-lg-3">
                                      <label
                                        className="form-check-label"
                                        htmlFor=""
                                      >
                                        Country of Origin
                                      </label>
                                    </div>
                                    <div className="col-lg-3">
                                      <div className="rs-container">
                                    <Select
                                      classNamePrefix="rs"
                                      options={countryOptions}
                                      value={countryOptions.find(
                                          (option) => option.value === ENVSampleDetails?.countryofOrigin
                                      )}
                                        onChange={handleSelectedChange("countryofOrigin")}
                                      isDisabled={
                                        isCancelRequest ||
                                        IsAcknowledgeRequest ||
                                        IsAcknowledge ||
                                        IsSubmitresultRequest
                                      }
                                      placeholder="Select a country"
                                        isSearchable
                                        isClearable={false}

                                        /* --- FIXED DROPDOWN BEHAVIOR --- */
                                        
                                        maxMenuHeight={260}                                        
                                        menuPlacement="auto"                                                                            
                                        filterOption={(option, inputValue) =>
                                          option.label.toLowerCase().includes(inputValue.toLowerCase())
                                        }
                                      />
                                    </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* <div className="col-lg-6">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <label
                                      className="form-check-label"
                                      htmlFor="samples"
                                    >
                                      Sample(s) to be collected or submitted?
                                    </label>
                                  </div>
                                  <div className="col-lg-6">
                                    <select
                                      title="samples"
                                      name="samplesCollectedOrSubmitted"
                                      className={`form-control ${
                                        ENVSampleDetails?.samplesCollectedOrSubmittedErrMsg
                                          ? "border-danger op05"
                                          : ""
                                      }`}
                                      value={
                                        ENVSampleDetails?.samplesCollectedOrSubmitted
                                      }
                                      disabled
                                      required
                                    >
                                      <option value="Tobecollected">
                                        To be collected
                                      </option>
                                      <option value="Tobesubmitted">
                                        To be submitted
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div> */}
                              {/* {ENVSampleDetails?.samplesCollectedOrSubmitted ===
                              "Tobecollected" && (
                              <div className="row-mt-2">
                                <div className="row">
                                  <div className="col-lg-3">
                                    <label
                                      className="form-check-label"
                                      htmlFor=""
                                    >
                                      Courier Name
                                    </label>
                                  </div>
                                  <div className="col-lg-3">
                                    <select
                                      title="courierName"
                                      name="courierName"
                                      className="form-control"
                                      value={ENVSampleDetails?.courierName}
                                      disabled={
                                        amendCase == "CASE4" ||
                                        isCancelRequest ||
                                        IsAcknowledgeRequest ||
                                        IsSubmitresultRequest
                                      }
                                      onChange={(e) =>
                                        handleENVSampleDetails(e, "select")
                                      }
                                    >
                                      <option value="" disabled hidden>
                                        Select a courier
                                      </option>
                                      <option value="courierOption1">
                                        Courier Option 1
                                      </option>
                                      <option value="courierOption2">
                                        Courier Option 2
                                      </option>
                                    </select>
                                  </div>

                                  <div className="col-lg-3">
                                    <label
                                      className="form-check-label"
                                      htmlFor="courierTrackingNo"
                                    >
                                      Courier tracking number
                                    </label>
                                  </div>
                                  <div className="col-lg-3">
                                    <input
                                      type="text"
                                      id="courierTrackingNo"
                                      name="courierTrackingNo"
                                      value={
                                        ENVSampleDetails?.courierTrackingNo
                                      }
                                      className="form-control"
                                      disabled={
                                        amendCase == "CASE4" ||
                                        isCancelRequest ||
                                        IsAcknowledgeRequest ||
                                        IsSubmitresultRequest
                                      }
                                      onChange={(e) =>
                                        handleENVSampleDetails(e, "datetime")
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            )} */}

                              {modeOfPayment === "Biosurveillance" && (
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="row">
                                      <div className="col-lg-6">
                                        <label
                                          className="form-check-label"
                                          htmlFor=""
                                        >
                                          Biosurveillance Program
                                          <span className="star-red">*</span>
                                        </label>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="col-lg-12 mt-2">
                                          <select
                                            className={`form-select ${
                                              ENVSampleDetails?.bioSurveillanceProgramErrMsg
                                                ? "border-danger op05"
                                                : ""
                                            }`}
                                            aria-label="Default select example"
                                            name="bioSurveillanceProgram"
                                            value={
                                              ENVSampleDetails?.bioSurveillanceProgram
                                            }
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                            onChange={(e) =>
                                              handleENVSampleDetails(
                                                e,
                                                "string"
                                              )
                                            }
                                          >
                                            <option selected>
                                              -- Select --
                                            </option>
                                            {bioSurveillanceProgramsOptions &&
                                              bioSurveillanceProgramsOptions.map(
                                                (x) => {
                                                  return (
                                                    <option value={x.label}>
                                                      {x.label}
                                                    </option>
                                                  );
                                                }
                                              )}
                                          </select>
                                          {ENVSampleDetails?.bioSurveillanceProgramErrMsg && (
                                            <div className="error-message">
                                              <FontAwesomeIcon
                                                className="me-1"
                                                icon={faCircleExclamation}
                                              />
                                              Please select Biosurveillance
                                              Program.
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}

                              <div className="row mt-2">
                                <div className="col-lg-3">
                                  <label
                                    className="form-check-label"
                                    htmlFor="samplingFromDate"
                                  >
                                    Sampling From Date
                                    <span className="star-red">*</span>
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <input
                                    type="datetime-local"
                                    className={`form-control ${
                                      ENVSampleDetails?.samplingToDate &&
                                      moment(
                                        ENVSampleDetails?.samplingToDate
                                      ).isBefore(
                                        moment(
                                          ENVSampleDetails?.samplingFromDate
                                        )
                                      )
                                        ? "border-danger"
                                        : ""
                                    }`}
                                    name="samplingFromDate"
                                    disabled={
                                      isCancelRequest ||
                                      IsAcknowledgeRequest ||
                                      IsAcknowledge ||
                                      IsSubmitresultRequest
                                    }
                                    value={
                                      ENVSampleDetails?.samplingFromDate
                                        ? moment(
                                            ENVSampleDetails?.samplingFromDate
                                          ).format("YYYY-MM-DDTHH:mm")
                                        : ""
                                    }
                                    onChange={(e) =>
                                      handleENVSampleDetails(
                                        e,
                                        "datetime-local"
                                      )
                                    }
                                    /*max={
                                      ENVSampleDetails?.samplingToDate
                                        ? moment(
                                            ENVSampleDetails?.samplingToDate
                                          ).format("YYYY-MM-DDTHH:mm")
                                        : maxDateTime
                                    }*/
                                  />
                                  {ENVSampleDetails?.samplingFromDateErrMsg && (
                                    <div className="error-message">
                                      <FontAwesomeIcon
                                        className="me-1"
                                        icon={faCircleExclamation}
                                      />
                                      {ENVSampleDetails?.samplingFromDateErrMsg}
                                    </div>
                                  )}
                                </div>

                                <div className="col-lg-3">
                                  <label
                                    className="form-check-label"
                                    htmlFor="samplingToDate"
                                  >
                                    Sampling To Date
                                    <span className="star-red">*</span>
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <input
                                    type="datetime-local"
                                    className={`form-control ${
                                      ENVSampleDetails?.samplingFromDate &&
                                      moment(
                                        ENVSampleDetails?.samplingToDate
                                      ).isBefore(
                                        moment(
                                          ENVSampleDetails?.samplingFromDate
                                        )
                                      )
                                        ? "border-danger"
                                        : ""
                                    }`}
                                    name="samplingToDate"
                                    disabled={
                                      isCancelRequest ||
                                      IsAcknowledgeRequest ||
                                      IsAcknowledge ||
                                      IsSubmitresultRequest
                                    }
                                    value={
                                      ENVSampleDetails?.samplingToDate
                                        ? moment(
                                            ENVSampleDetails.samplingToDate
                                          ).format("YYYY-MM-DDTHH:mm")
                                        : ""
                                    }
                                    onChange={(e) =>
                                      handleENVSampleDetails(
                                        e,
                                        "datetime-local"
                                      )
                                    }
                                    min={
                                      ENVSampleDetails?.samplingFromDate
                                        ? moment(
                                            ENVSampleDetails?.samplingFromDate
                                          ).format("YYYY-MM-DDTHH:mm")
                                        : ""
                                    }
                                  />
                                  {ENVSampleDetails?.samplingToDateErrMsg && (
                                    <div className="error-message">
                                      <FontAwesomeIcon
                                        className="me-1"
                                        icon={faCircleExclamation}
                                      />
                                      {ENVSampleDetails?.samplingToDateErrMsg}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="row mt-2">
                                <div className="col-lg-3">
                                  <label htmlFor="sampledBy">
                                    Sampled By{" "}
                                    <span className="star-red">*</span>
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <input
                                    type="text"
                                    id="sampledBy"
                                    name="sampledBy"
                                    value={ENVSampleDetails?.sampledBy}
                                    disabled={
                                      isCancelRequest ||
                                      IsAcknowledgeRequest ||
                                      IsAcknowledge ||
                                      IsSubmitresultRequest
                                    }
                                    maxLength={100}
                                    className="form-control"
                                    onChange={(e) =>
                                      handleENVSampleDetails(e, "string")
                                    }
                                  />
                                  {ENVSampleDetails?.sampledByErrMsg && (
                                    <div className="error-message">
                                      <FontAwesomeIcon
                                        className="me-1"
                                        icon={faCircleExclamation}
                                      />
                                      Please Fill Sampled By.
                                    </div>
                                  )}
                                </div>
                                <div className="col-lg-3">
                                  <label
                                    className="form-check-label"
                                    htmlFor="referringVeterinarian"
                                  >
                                    Referring Veterinarian
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="referringVeterinarian"
                                    maxLength={100}
                                    value={
                                      ENVSampleDetails?.referringVeterinarian
                                    }
                                    onChange={(e) =>
                                      handleENVSampleDetails(e, "string")
                                    }
                                    disabled={
                                      isCancelRequest ||
                                      IsAcknowledgeRequest ||
                                      IsAcknowledge ||
                                      IsSubmitresultRequest
                                    }
                                  />
                                </div>
                              </div>
                              <div className="row mt-2">
                                <div className="col-lg-3">
                                  <label htmlFor="crossReference">
                                    Cross Reference
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <input
                                    type="text"
                                    id="crossReference"
                                    name="crossReference"
                                    value={ENVSampleDetails?.crossReference}
                                    disabled={
                                      isCancelRequest ||
                                      IsAcknowledgeRequest ||
                                      IsAcknowledge ||
                                      IsSubmitresultRequest
                                    }
                                    maxLength={100}
                                    className="form-control"
                                    onChange={(e) =>
                                      handleENVSampleDetails(e, "string")
                                    }
                                  />
                                </div>
                              </div>

                              <div className="row mt-3">
                                <div className="col-lg-12">
                                  <label
                                    className="form-check-label"
                                    htmlFor="flexRadioDefault1"
                                  >
                                    <a
                                      href="#"
                                      className="font-weight-500"
                                      onClick={handleToggleFarmDetails}
                                    >
                                      Farm/Location Details{" "}
                                      {showFarmDetails ? "[-]" : "[+]"}
                                    </a>
                                  </label>
                                </div>
                              </div>
                              {showFarmDetails && (
                                <>
                                  {modeOfPayment === "Biosurveillance" && (
                                    <div className="row mb-3">
                                      <div className="col-lg-6">
                                        <div className="row">
                                          <div className="col-lg-6">
                                            <label
                                              className="form-check-label"
                                              htmlFor=""
                                            >
                                              Farm Code
                                            </label>
                                          </div>
                                          <div className="col-lg-6">
                                            <div className="col-lg-12 mt-2">
                                              <select
                                                className="form-select"
                                                aria-label="Default select example"
                                                name="farmCode"
                                                value={
                                                  ENVSampleDetails?.farmCode
                                                }
                                                disabled={
                                                  isCancelRequest ||
                                                  IsAcknowledgeRequest ||
                                                  IsAcknowledge ||
                                                  IsSubmitresultRequest
                                                }
                                                onChange={(e) =>
                                                  handleENVSampleDetails(
                                                    e,
                                                    "string"
                                                  )
                                                }
                                              >
                                                <option selected>
                                                  -- Select --
                                                </option>
                                                {premisesCodeOptions.map(
                                                  (option) => (
                                                    <option
                                                      key={option.value}
                                                      value={option.value}
                                                    >
                                                      {option.label}
                                                    </option>
                                                  )
                                                )}
                                                <option
                                                  key="specialFarmCode"
                                                  value="specialfarmCode"
                                                >
                                                  Special Farm Code
                                                </option>
                                              </select>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {ENVSampleDetails?.farmCode ===
                                    "specialfarmCode" && (
                                    <div className="row mb-3">
                                      <div className="col-lg-6">
                                        <div className="row align-items-center">
                                          <div className="col-lg-6">
                                            <label
                                              className="form-check-label"
                                              htmlFor="specialFarmCode"
                                            >
                                              Special Farm Code
                                            </label>
                                          </div>
                                          <div className="col-lg-6">
                                            <input
                                              id="specialFarmCode"
                                              type="text"
                                              className="form-control"
                                              disabled={
                                                isCancelRequest ||
                                                IsAcknowledgeRequest ||
                                                IsAcknowledge ||
                                                IsSubmitresultRequest
                                              }
                                              placeholder={
                                                showPlaceholder
                                                  ? "Enter Special Farm Code"
                                                  : ""
                                              }
                                              name="specialFarmCode"
                                              value={
                                                ENVSampleDetails?.specialFarmCode ||
                                                ""
                                              }
                                              maxLength={100}
                                              onChange={(e) =>
                                                handleENVSampleDetails(
                                                  e,
                                                  "string"
                                                )
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  <div className="row align-items-center">
                                    <div className="col-lg-3">
                                      <label
                                        htmlFor="latitude"
                                        className="mb-0"
                                      >
                                        Latitude (Decimal Degrees)
                                      </label>
                                    </div>

                                    <div className="col-lg-3">
                                      <input
                                        type="text"
                                        id="latitude"
                                        name="latitude"
                                        value={ENVSampleDetails?.latitude}
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledge ||
                                          IsAcknowledgeRequest ||
                                          IsSubmitresultRequest
                                        }
                                        className="form-control"
                                        placeholder={
                                          showPlaceholder ? "123.123456" : ""
                                        }
                                        onChange={(e) =>
                                          handleENVSampleDetails(e, "string")
                                        }
                                        maxLength={100}
                                      />
                                    </div>

                                    <div className="col-lg-3">
                                      <label
                                        htmlFor="longitude"
                                        className="mb-0"
                                      >
                                        Longitude (Decimal Degrees)
                                      </label>
                                    </div>

                                    <div className="col-lg-3">
                                      <input
                                        type="text"
                                        id="longitude"
                                        name="longitude"
                                        value={ENVSampleDetails?.longitude}
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledge ||
                                          IsAcknowledgeRequest ||
                                          IsSubmitresultRequest
                                        }
                                        className="form-control"
                                        placeholder={
                                          showPlaceholder ? "123.123456" : ""
                                        }
                                        onChange={(e) =>
                                          handleENVSampleDetails(e, "string")
                                        }
                                        maxLength={100}
                                      />
                                    </div>
                                  </div>
                                  <div className="row mt-2 align-items-center">
                                    <div className="col-lg-3">
                                      <label htmlFor="locationName">
                                        Location Name
                                      </label>
                                    </div>
                                    <div className="col-lg-3">
                                      <input
                                        type="text"
                                        id="locationName"
                                        name="locationName"
                                        value={ENVSampleDetails?.locationName}
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledge ||
                                          IsAcknowledgeRequest ||
                                          IsSubmitresultRequest
                                        }
                                        className="form-control"
                                        onChange={(e) =>
                                          handleENVSampleDetails(e, "string")
                                        }
                                        maxLength={100}
                                      />
                                    </div>
                                  </div>

                                  <div className="row">
                                    <div className="col-lg-3">
                                      <label
                                        className="form-check-label"
                                        htmlFor="addressType"
                                      >
                                        Farm/Location Address
                                      </label>
                                    </div>
                                    <div className="col-lg-3">
                                      <div className="form-checked">
                                        <label
                                          className="form-check-label"
                                          htmlFor="local"
                                        >
                                          <input
                                            type="radio"
                                            id="local"
                                            name="addressType"
                                            value="Local"
                                            className="form-check-input"
                                            checked={
                                              ENVSampleDetails?.addressType ===
                                              "Local"
                                            }
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledge ||
                                              IsAcknowledgeRequest ||
                                              IsSubmitresultRequest
                                            }
                                            onChange={(e) =>
                                              handleENVSampleDetails(e, "radio")
                                            }
                                          />
                                          Local
                                        </label>

                                        <label
                                          className="form-check-label"
                                          htmlFor="foreign"
                                        >
                                          <input
                                            type="radio"
                                            id="foreign"
                                            name="addressType"
                                            value="Foreign"
                                            className="form-check-input"
                                            checked={
                                              ENVSampleDetails?.addressType ===
                                              "Foreign"
                                            }
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                            onChange={(e) =>
                                              handleENVSampleDetails(e, "radio")
                                            }
                                          />
                                          Foreign
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="address">
                                    <div className="row mt-2">
                                      <div
                                        className={
                                          ENVSampleDetails?.addressType ===
                                            "Local" &&
                                          modeOfPayment !== "Biosurveillance"
                                            ? "col-lg-9"
                                            : "col-lg-12"
                                        }
                                      >
                                        <div>
                                          <label htmlFor="postalCode">
                                            Postal Code
                                          </label>
                                          <input
                                            type="text"
                                            id="postalCode"
                                            name="postalCode"
                                            className="form-control"
                                            maxLength={50}
                                            value={ENVSampleDetails?.postalCode}
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                            onChange={(e) => {
                                              const newValue = e.target.value;
                                              setpostalCode({
                                                ...postalCode,
                                                postalCode: newValue,
                                              });
                                              setENVSampleDetails({
                                                ...ENVSampleDetails,
                                                postalCode: newValue,
                                              });
                                            }}
                                          />
                                        </div>
                                      </div>
                                      {modeOfPayment !== "Biosurveillance" &&
                                        ENVSampleDetails?.addressType ===
                                          "Local" && (
                                          <div className="col-lg-3">
                                            <div className="row">
                                              <div className="col-lg-12">
                                                <label htmlFor="button"></label>
                                                <br />
                                                <div>
                                                  <Button
                                                    className="btttn"
                                                    onClick={() => {
                                                      if (
                                                        ENVSampleDetails.addressType
                                                      ) {
                                                        fetchData(
                                                          ENVSampleDetails.addressType
                                                        );
                                                      } else {
                                                        message(
                                                          NotifyType.Error,
                                                          "Please select an address type (Local or Foreign) before retrieving."
                                                        );
                                                      }
                                                    }}
                                                  >
                                                    Retrieve
                                                  </Button>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                    </div>

                                    <div className="row mt-2">
                                      <div>
                                        <label htmlFor="streetName">
                                          Street/Road Name
                                        </label>
                                        <input
                                          type="text"
                                          id="streetName"
                                          name="streetName"
                                          value={ENVSampleDetails?.streetName}
                                          className="form-control"
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                          onChange={(e) =>
                                            handleENVSampleDetails(e, "string")
                                          }
                                          maxLength={100}
                                        />
                                      </div>
                                    </div>

                                    <div className="row mt-4">
                                      <div className="col-lg-4">
                                        <label htmlFor="blockHouseNo">
                                          Block/House No
                                        </label>
                                        <input
                                          type="text"
                                          id="blockHouseNo"
                                          name="blockHouseNo"
                                          value={ENVSampleDetails?.blockHouseNo}
                                          className="form-control"
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledge ||
                                            IsAcknowledgeRequest ||
                                            IsSubmitresultRequest
                                          }
                                          onChange={(e) =>
                                            handleENVSampleDetails(e, "string")
                                          }
                                          maxLength={100}
                                        />
                                      </div>
                                      <div className="block">
                                        <label htmlFor="level">Level</label>
                                        <input
                                          type="text"
                                          id="level"
                                          name="level"
                                          value={ENVSampleDetails?.level}
                                          className="form-control"
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                          onChange={(e) =>
                                            handleENVSampleDetails(e, "string")
                                          }
                                          maxLength={100}
                                        />
                                      </div>
                                      <div className="col-lg-4">
                                        <label htmlFor="unitNo">Unit No</label>
                                        <input
                                          type="text"
                                          id="unitNo"
                                          name="unitNo"
                                          value={ENVSampleDetails?.unitNo}
                                          className="form-control"
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                          onChange={(e) =>
                                            handleENVSampleDetails(e, "string")
                                          }
                                          maxLength={100}
                                        />
                                      </div>
                                    </div>

                                    <div className="row mt-2">
                                      <div>
                                        <label htmlFor="buildingName">
                                          Building Name
                                        </label>
                                        <input
                                          type="text"
                                          id="buildingName"
                                          name="buildingName"
                                          value={ENVSampleDetails?.buildingName}
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                          className="form-control"
                                          onChange={(e) =>
                                            handleENVSampleDetails(e, "string")
                                          }
                                          maxLength={100}
                                        />
                                      </div>
                                    </div>

                                    <div className="row mt-4">
                                      <div className="col-lg-6">
                                        <label htmlFor="cityName">
                                          City Name
                                        </label>
                                        <input
                                          type="text"
                                          id="cityName"
                                          name="cityName"
                                          value={ENVSampleDetails?.cityName}
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledge ||
                                            IsAcknowledgeRequest ||
                                            IsSubmitresultRequest
                                          }
                                          className="form-control"
                                          onChange={(e) =>
                                            handleENVSampleDetails(e, "string")
                                          }
                                          maxLength={100}
                                        />
                                      </div>

                                      <div className="col-lg-6">
                                        <label htmlFor="State">
                                          State/Province
                                        </label>
                                        <input
                                          type="text"
                                          id="state"
                                          name="state"
                                          value={ENVSampleDetails?.state}
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                          className="form-control"
                                          onChange={(e) =>
                                            handleENVSampleDetails(e, "string")
                                          }
                                          maxLength={100}
                                        />
                                      </div>
                                    </div>

                                    <div className="row mt-2">
                                      <div>
                                        <label htmlFor="country">Country</label>
                                        <input
                                          type="text"
                                          id="country"
                                          name="country"
                                          value={ENVSampleDetails?.country}
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                          className="form-control"
                                          onChange={(e) =>
                                            handleENVSampleDetails(e, "string")
                                          }
                                          maxLength={100}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>

                            <div className="row mt-3">
                              <div className="col-lg-12">
                                <label
                                  className="form-check-label"
                                  htmlFor="flexRadioDefault1"
                                >
                                  <a
                                    href="#"
                                    className="font-weight-500"
                                    onClick={handleToggleForm}
                                  >
                                    History & Remarks:{" "}
                                    {showForm ? "[-]" : "[+]"}
                                  </a>
                                </label>
                              </div>
                            </div>
                            {showForm && (
                              <div className="row">
                                <div className="col-lg-3">
                                  <label htmlFor="historyAndRemarks"></label>
                                </div>
                                <div className="col-lg-9">
                                  <textarea
                                    id="historyAndRemarks"
                                    name="histrory_Remarks"
                                    value={ENVSampleDetails?.histrory_Remarks}
                                    className="form-control"
                                    disabled={
                                      isCancelRequest ||
                                      IsAcknowledgeRequest ||
                                      IsAcknowledge ||
                                      IsSubmitresultRequest
                                    }
                                    onChange={(e) =>
                                      handleENVSampleDetails(e, "string")
                                    }
                                    maxLength={500}
                                  />
                                  <p className="text-muted small mt-1">
                                    {ENVSampleDetails?.histrory_Remarks
                                      ?.length || 0}{" "}
                                    / 500 characters
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {isCancelRequest ? (
                        <div className="personal-info">
                          <div className="clonable-block" data-toggle="cloner">
                            <div className="clonable" data-clone-number="1">
                              <div className="info-heading">
                                <h2>
                                  Reason(s) for cancellation
                                  <span className="star-red">*</span>
                                </h2>
                              </div>
                              <div className="info-content">
                                <textarea
                                  className="form-control"
                                  placeholder=""
                                  name="cancel-request-comments"
                                  value={cancelComments}
                                  onChange={(e) =>
                                    setCancelComments(e.target.value)
                                  }
                                  maxLength={500}
                                ></textarea>
                                {cancelCommentsErrMsg && (
                                  <div className="error-message">
                                    <FontAwesomeIcon
                                      className="me-1"
                                      icon={faCircleExclamation}
                                    />
                                    Please fill Reason(s) for cancellation
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </Tab>
                  )}
                  {!(IsAcknowledge || IsSubmitresultRequest) && (
                    <Tab eventKey={2} title="Samples & Tests">
                      <div>
                        {rejectedTestsMessage && (
                          <div className="alert alert-warning">
                            {rejectedTestsMessage}
                          </div>
                        )}
                        {samplesAndTests &&
                          samplesAndTests.map(
                            (sample: IENVSamplesAndTests, index: number) => {
                              return (
                                <div className="personal-info" key={index}>
                                  <div
                                    className="clonable-block"
                                    data-toggle="cloner"
                                  >
                                    <div
                                      className="clonable"
                                      data-clone-number={index + 1}
                                    >
                                      <div className="info-heading">
                                        {amendCase !== "CASE4" &&
                                        !isCancelRequest &&
                                        !IsAcknowledge &&
                                        !IsSubmitresultRequest &&
                                        !IsAcknowledgeRequest ? (
                                          <ul className="card-icons float-end">
                                            <li>
                                              <button
                                                className="icon-button"
                                                title="New"
                                                onClick={handleAddSample}
                                              >
                                                <FontAwesomeIcon
                                                  icon={faPlus}
                                                />
                                              </button>
                                            </li>
                                            <li className="copy-button-container">
                                              <button
                                                className="icon-button"
                                                title="Copy"
                                                onClick={() =>
                                                  handleCopyButtonClick(index)
                                                }
                                              >
                                                <FontAwesomeIcon
                                                  icon={faCopy}
                                                />
                                              </button>
                                              <input
                                                type="number"
                                                className="copy-input"
                                                min="1"
                                                value={copyCount}
                                                onChange={handleCopyInputChange}
                                              />
                                            </li>

                                            <li>
                                              <button
                                                className="icon-button"
                                                onClick={() =>
                                                  handleDeleteSample(sample?.id)
                                                }
                                              >
                                                <FontAwesomeIcon
                                                  icon={faTrashCan}
                                                />
                                              </button>
                                            </li>
                                          </ul>
                                        ) : (
                                          ""
                                        )}
                                        <h2 className="pb-0">
                                          Serial number {index + 1}
                                        </h2>
                                      </div>
                                      <div className="info-content">
                                        <div className="table-responsive mt-2 mb-2">
                                          <table className="table table-striped product_table start_table">
                                            <thead>
                                              <tr>
                                                <th className="w-25">
                                                  Animal Type
                                                  <span className="star-red">
                                                    *
                                                  </span>
                                                </th>
                                                <th className="w-25">
                                                  <center>
                                                    {" "}
                                                    Test Information
                                                    <span className="star-red">
                                                      *
                                                    </span>
                                                  </center>
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <div className="rs-container rs-in-table">
                                                  <Select
                                                    id={`species-${index}`}
                                                    className={
                                                      sample?.speciesErrMsg
                                                        ? "border-danger"
                                                        : ""
                                                    }
                                                    classNamePrefix="rs"
                                                    options={
                                                      speciesSelectOptions
                                                    }
                                                    value={
                                                      speciesSelectOptions?.find(
                                                        (option: any) =>
                                                          option.value ===
                                                          sample.species
                                                      ) || null
                                                    }
                                                    onChange={(
                                                      selectedOption
                                                    ) => {
                                                      handleSelectChange(
                                                        index,
                                                        "species"
                                                      )(selectedOption);
                                                    }}
                                                    isSearchable={true}
                                                    isClearable={false}
                                                    maxMenuHeight={260}
                                                    menuPlacement="auto"
                                                    placeholder={
                                                      showPlaceholder
                                                        ? "Select Animal Type"
                                                        : ""
                                                    }
                                                    isDisabled={
                                                      isCancelRequest ||
                                                      IsAcknowledge ||
                                                      IsSubmitresultRequest
                                                    }
                                                    filterOption={(option, inputValue) =>
                                                      option.label.toLowerCase().includes(inputValue.toLowerCase())
                                                    }
                                                  />
                                                  {sample.species?.toUpperCase() ===
                                                    "Others".toUpperCase() && (
                                                    <input
                                                      type="text"
                                                      name="otherSpecies"
                                                      className="form-control mt-2"
                                                      value={
                                                        sample?.otherSpecies
                                                      }
                                                      maxLength={100}
                                                      onChange={handleSamplesAndTestsChange(
                                                        index,
                                                        "string"
                                                      )}
                                                      disabled={
                                                        isCancelRequest ||
                                                        IsAcknowledgeRequest ||
                                                        IsAcknowledge ||
                                                        IsSubmitresultRequest
                                                      }
                                                      placeholder={
                                                        showPlaceholder
                                                          ? "Enter Animal Type"
                                                          : ""
                                                      }
                                                    />
                                                  )}
                                                  {sample?.speciesErrMsg && (
                                                    <div className="error-message">
                                                      <FontAwesomeIcon
                                                        className="me-1"
                                                        icon={
                                                          faCircleExclamation
                                                        }
                                                      />
                                                      Please fill Animal Type.
                                                    </div>
                                                  )}
                                                  </div>
                                                </td>
                                                <td>
                                                  <button
                                                    className="btn btn-outline-success w-100"
                                                    type="button"
                                                    onClick={() =>
                                                      handleShowSearchTestsModal(
                                                        index
                                                      )
                                                    }
                                                    disabled={
                                                      amendCase == "CASE4" ||
                                                      isCancelRequest ||
                                                      IsAcknowledgeRequest ||
                                                      IsAcknowledge ||
                                                      IsSubmitresultRequest
                                                    }
                                                  >
                                                    Search Test
                                                  </button>
                                                  {sample?.labENVTestDetailsErrMsg && (
                                                    <div className="error-message">
                                                      <FontAwesomeIcon
                                                        className="me-1"
                                                        icon={
                                                          faCircleExclamation
                                                        }
                                                      />
                                                      Please add Test
                                                      Information.
                                                    </div>
                                                  )}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td className="fnt-wg tr-ignore">
                                                  <div className="mb-3 ">
                                                    <div className="mb-2">
                                                      <label
                                                        htmlFor="staticEmail"
                                                        className="col-form-label"
                                                      >
                                                        Sample Marking{" "}
                                                        <span className="star-red">
                                                          *
                                                        </span>
                                                      </label>
                                                      <div className="input-group date">
                                                        <input
                                                          type="text"
                                                          name="sampleMarking"
                                                          value={
                                                            sample?.sampleMarking
                                                          }
                                                          maxLength={100}
                                                          className={`form-control ${
                                                            !sample?.sampleMarking
                                                              ? "border-danger op05"
                                                              : ""
                                                          }`}
                                                          onChange={handleSamplesAndTestsChange(
                                                            index,
                                                            "string"
                                                          )}
                                                          disabled={
                                                            isCancelRequest ||
                                                            IsAcknowledgeRequest ||
                                                            IsAcknowledge ||
                                                            IsSubmitresultRequest
                                                          }
                                                        />
                                                      </div>
                                                      {sample?.sampleMarkingErrMsg && (
                                                        <div className="error-message">
                                                          <FontAwesomeIcon
                                                            className="me-1"
                                                            icon={
                                                              faCircleExclamation
                                                            }
                                                          />
                                                          {
                                                            sample.sampleMarkingErrMsg
                                                          }
                                                        </div>
                                                      )}
                                                    </div>
                                                  </div>
                                                </td>
                                                <td className="fnt-wg tr-ignore">
                                                  <div className="mb-3 ">
                                                    <div className="mb-2">
                                                      <label
                                                        htmlFor="staticEmail"
                                                        className="col-form-label"
                                                      >
                                                        Number of Samples
                                                        <span className="star-red">
                                                          *
                                                        </span>
                                                      </label>
                                                      <div className="input-group date">
                                                        <input
                                                          type="number"
                                                          min="1"
                                                          name="noOfSamples"
                                                          className="form-control"
                                                          value={
                                                            sample?.noOfSamples ??
                                                            1
                                                          }
                                                          disabled={
                                                            amendCase ==
                                                              "CASE4" ||
                                                            isCancelRequest ||
                                                            IsAcknowledgeRequest ||
                                                            IsAcknowledge ||
                                                            IsSubmitresultRequest
                                                          }
                                                          onChange={handleSamplesAndTestsChange(
                                                            index,
                                                            "number"
                                                          )}
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                                {/* <td className="fnt-wg tr-ignore">
                                                  <div className="mb-3">
                                                    <div className="mb-2">
                                                      <label className="col-form-label float-start">
                                                        Latitude (Decimal
                                                        Degrees)
                                                      </label>
                                                      <div className="input-group date">
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          name="latitude"
                                                          value={
                                                            sample?.latitude
                                                          }
                                                          placeholder={
                                                            showPlaceholder
                                                              ? "123.123456"
                                                              : ""
                                                          }
                                                          required
                                                          disabled={
                                                            isCancelRequest ||
                                                            IsAcknowledgeRequest ||
                                                            IsAcknowledge ||
                                                            IsSubmitresultRequest
                                                          }
                                                          maxLength={100}
                                                          onChange={handleSamplesAndTestsChange(
                                                            index,
                                                            "string"
                                                          )}
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>

                                                <td className="fnt-wg tr-ignore">
                                                  <div className="mb-3">
                                                    <div className="mb-2">
                                                      <label className="col-form-label float-start">
                                                        Longitude (Decimal
                                                        Degrees)
                                                      </label>
                                                      <div className="input-group date">
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          name="longitude"
                                                          value={
                                                            sample?.longitude
                                                          }
                                                          placeholder={
                                                            showPlaceholder
                                                              ? "123.123456"
                                                              : ""
                                                          }
                                                          required
                                                          disabled={
                                                            isCancelRequest ||
                                                            IsAcknowledgeRequest ||
                                                            IsAcknowledge ||
                                                            IsSubmitresultRequest
                                                          }
                                                          maxLength={100}
                                                          onChange={handleSamplesAndTestsChange(
                                                            index,
                                                            "string"
                                                          )}
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td> */}
                                              </tr>

                                              {sample.labENVTestDetails &&
                                                sample.labENVTestDetails
                                                  .filter(
                                                    (test) =>
                                                      test.testDescription !==
                                                      ""
                                                  )
                                                  .map((test, testIndex) => (
                                                    <tr
                                                      key={`test-row-${index}-${testIndex}`}
                                                    >
                                                      <td className="br-1">
                                                        <div className="mb-3">
                                                          <div className="mb-2">
                                                            <div className="test-detail">
                                                              <div
                                                                id={`testDescription-${index}-${test.labTestID}`}
                                                                className="test-description"
                                                                dangerouslySetInnerHTML={{
                                                                  __html:
                                                                    test.testDescription,
                                                                }}
                                                              />
                                                              {!(
                                                                amendCase ===
                                                                  "CASE4" ||
                                                                isCancelRequest ||
                                                                IsAcknowledgeRequest ||
                                                                IsAcknowledge ||
                                                                IsSubmitresultRequest
                                                              ) && (
                                                                <div
                                                                  className="test-remove-icon"
                                                                  onClick={() =>
                                                                    handleRemoveTest(
                                                                      sample.labENVTestDetails,
                                                                      test.testDescription,
                                                                      index
                                                                    )
                                                                  }
                                                                >
                                                                  <i className="bi bi-dash-circle"></i>
                                                                </div>
                                                              )}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </td>
                                                      <td>
                                                        <div className="mb-3">
                                                          <div className="mb-2">
                                                            <label
                                                              htmlFor={`repeatCount-${index}-${testIndex}`}
                                                              className="col-form-label float-start"
                                                            >
                                                              Number of Tests
                                                              <span className="star-red">
                                                                *
                                                              </span>
                                                            </label>
                                                            <div className="input-group date">
                                                              <input
                                                                type="number"
                                                                id={`repeatCount-${index}-${testIndex}`}
                                                                min="1"
                                                                className="form-control"
                                                                value={
                                                                  repeatCounts[
                                                                    index
                                                                  ]?.[
                                                                    testIndex
                                                                  ] ??
                                                                  test.nooftestsrequired
                                                                }
                                                                disabled={
                                                                  amendCase ==
                                                                    "CASE4" ||
                                                                  isCancelRequest ||
                                                                  IsAcknowledgeRequest ||
                                                                  IsAcknowledge ||
                                                                  IsSubmitresultRequest
                                                                }
                                                                onChange={(e) =>
                                                                  handleRepeatCountChange(
                                                                    index,
                                                                    testIndex,
                                                                    Math.min(
                                                                      Number(
                                                                        e.target
                                                                          .value
                                                                      ),
                                                                      1000
                                                                    )
                                                                  )
                                                                }
                                                              />
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  ))}
                                            </tbody>
                                          </table>
                                        </div>
                                        <hr />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          )}
                      </div>
                    </Tab>
                  )}
                  {!(IsAcknowledge || IsSubmitresultRequest) && (
                    <Tab eventKey={3} title="My Preference">
                      <div className="personal-info">
                        <div className="clonable-block">
                          <div className="clonable">
                            <div className="info-content">
                              <div className="row">
                                <div className="col-lg-6">
                                  <div className="row">
                                    <div className="col-lg-5">
                                      <label
                                        className="form-check-label"
                                        htmlFor="SpecialInstructions"
                                      >
                                        For Bacterial Culture Only
                                      </label>
                                    </div>
                                    <div className="col-lg-7 d-flex align-items-center">
                                      <input
                                        type="checkbox"
                                        className="form-check-input me-2"
                                        name="antimicrobialSusceptibilityTestRequired"
                                        onChange={(e) =>
                                          handleMyPreference(e, "checkbox")
                                        }
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsSubmitresultRequest ||
                                          IsAcknowledge ||
                                          amendCase === "CASE4"
                                        }
                                        checked={
                                          Preference?.antimicrobialSusceptibilityTestRequired
                                        }
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="antimicrobialSusceptibilityTestRequired"
                                      >
                                        Antimicrobial Susceptibility Test
                                        Required
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="row">
                                    <div className="col-lg-5">
                                      <label
                                        className="form-check-label"
                                        htmlFor="SpecialInstructions"
                                      >
                                        Special Instructions/ Additional
                                        Information
                                      </label>
                                    </div>
                                    <div className="col-lg-7">
                                      <textarea
                                        className="form-control"
                                        name="specialInstructions"
                                        onChange={(e) =>
                                          handleMyPreference(e, "input")
                                        }
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsSubmitresultRequest ||
                                          IsAcknowledge
                                        }
                                        maxLength={500}
                                        value={Preference?.specialInstructions}
                                      />
                                      <p className="text-muted small mt-1">
                                        {Preference?.specialInstructions
                                          ?.length || 0}{" "}
                                        / 500 characters
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="row mt-2 mt-lg-0">
                                    <div className="col-lg-5">
                                      <label
                                        className="form-check-label"
                                        htmlFor="otherRemarks"
                                      >
                                        Other Remarks
                                      </label>
                                    </div>
                                    <div className="col-lg-7">
                                      <textarea
                                        className="form-control"
                                        name="remarks"
                                        value={Preference?.remarks}
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                        maxLength={500}
                                        onChange={(e) =>
                                          handleMyPreference(e, "input")
                                        }
                                      />
                                      <p className="text-muted small mt-1">
                                        {Preference?.remarks?.length || 0} / 500
                                        characters
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6 mt-3">
                                  <div className="row">
                                    <div className="col-lg-5">
                                      <label
                                        htmlFor="supportDocuments"
                                        className="form-check-label"
                                        onMouseEnter={handleMouseEnter}
                                        onMouseLeave={handleMouseLeave}
                                        title="Documents allowed: pdf, docx, doc, jpg, jpeg, png, xlsx, xls."
                                      >
                                        Support Documents
                                        <span className="csp-ml-5">
                                          <FontAwesomeIcon
                                            icon={faInfoCircle}
                                          />
                                        </span>
                                      </label>
                                    </div>
                                    <div className="col-lg-7">
                                      <input
                                        type="file"
                                        className="form-control"
                                        id="SupportDocuments"
                                        multiple
                                        onChange={handledFileChange}
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                      />
                                      {Preference?.supportDocumentName && (
                                        <div className="file-view mt-2">
                                          {Preference.supportDocumentName
                                            .split(", ")
                                            .map((name, index) => (
                                              <div
                                                key={index}
                                                className="file-item d-flex align-items-center"
                                              >
                                                <div className="file-name">
                                                  {name}
                                                </div>
                                                {!(
                                                  amendCase === "CASE4" ||
                                                  isCancelRequest ||
                                                  IsAcknowledgeRequest ||
                                                  IsAcknowledge ||
                                                  IsSubmitresultRequest
                                                ) && (
                                                  <div
                                                    className="test-remove-icon ml-2"
                                                    onClick={() =>
                                                      handleRemoveFile(name)
                                                    }
                                                    title="Remove file"
                                                  >
                                                    <i className="bi bi-dash-circle"></i>
                                                  </div>
                                                )}
                                              </div>
                                            ))}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                <div className="col-lg-6 mt-3">
                                  <div className="row">
                                    <div className="col-lg-5">
                                      <label
                                        className="form-check-label"
                                        htmlFor="modeOfReceiving"
                                      >
                                        Mode of receiving report
                                        <span className="star-red">*</span>
                                      </label>
                                    </div>
                                    <div className="col-lg-7">
                                      <select
                                        name="modeOfReceiving"
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                        value={Preference?.modeOfReceiving}
                                        onChange={(e) => {
                                          handleMyPreference(e, "number");

                                          const value = Number(e.target.value);

                                          if (value === 1 || value === 3) {
                                            setPreference((prevState) => ({
                                              ...prevState,
                                              hardcopy: "Yes",
                                            }));
                                          } else {
                                            setPreference((prevState) => ({
                                              ...prevState,
                                              hardcopy: "No",
                                            }));
                                          }
                                        }}
                                        className="form-select"
                                        aria-label="Mode of receiving report"
                                      >
                                        <option value="" selected>
                                          Select an option
                                        </option>
                                        <option value={2}>Email</option>
                                      </select>

                                      {Preference?.modeOfReceivingErrMsg && (
                                        <div className="error-message">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          Please select Mode of Report.
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                {Preference?.modeOfReceiving === 1 && (
                                  <div className="row mt-2">
                                    <div className="col-lg-6">
                                      <label className="form-check-label fw-bold mb-2">
                                        Please select the address for mailing:
                                      </label>
                                      <select
                                        name="mailingAddress"
                                        className="form-select mb-3"
                                        value={Preference?.mailingAddress}
                                        onChange={(e) =>
                                          handleMyPreference(e, "number")
                                        }
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                      >
                                        <option value="" selected>
                                          Please Select address
                                        </option>
                                        <option value={1}>
                                          Same as mailing address
                                        </option>
                                        <option value={2}>
                                          Same as billing address
                                        </option>
                                        <option value={3}>
                                          Others (please specify)
                                        </option>
                                      </select>
                                      {Preference?.mailingAddressErrMsg && (
                                        <div className="text-danger mt-2">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          Please Select the address
                                        </div>
                                      )}

                                      {Preference?.mailingAddress === 3 && (
                                        <div className="col-lg-12">
                                          <textarea
                                            className="form-control mt-2"
                                            placeholder="Enter address"
                                            name="customAddress"
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                            value={
                                              Preference?.customAddress || ""
                                            }
                                            onChange={(e) =>
                                              handleMyPreference(e, "input")
                                            }
                                          />
                                        </div>
                                      )}
                                      {Preference?.customAddressErrMsg && (
                                        <div className="text-danger mt-2">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          Please enter address
                                        </div>
                                      )}

                                      <div className="alert alert-warning mt-3">
                                        Please note that NParks is not liable
                                        for lost mail, and any additional copies
                                        of laboratory reports are subject to
                                        additional charges.
                                      </div>

                                      <div className="form-check mt-3">
                                        <input
                                          type="checkbox"
                                          className="form-check-input mt-2"
                                          id="acknowledgeCheckbox"
                                          name="acknowledge"
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                          checked={
                                            Preference?.acknowledge || false
                                          }
                                          onChange={(e) =>
                                            handleMyPreference(e, "checkbox")
                                          }
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="acknowledgeCheckbox"
                                        >
                                          I acknowledge the above information
                                        </label>
                                      </div>

                                      {Preference?.acknowledgeErrMsg && (
                                        <div className="text-danger mt-2">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          You must acknowledge before proceeding
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Tab>
                  )}
                  {(IsSubmitresultRequest || IsAcknowledge) && (
                    <Tab eventKey={4} title="Results">
                      {samplesAndTests &&
                        samplesAndTests
                          .filter((sample) => {
                            return sample.labENVTestDetails.some(
                              (test: any) => {
                                const isValidTest =
                                  test.isThirdPartyLab === 1 &&
                                  test.rowId === testRowId &&
                                  test.thirdPartyNric === customerNRIC &&
                                  (test.testStatus === null ||
                                    test.testStatus !== 8);

                                return isValidTest;
                              }
                            );
                          })

                          .map(
                            (
                              sample: IENVSamplesAndTests,
                              sampleIndex: number
                            ) => {
                              return (
                                <div
                                  className="personal-info"
                                  key={sampleIndex}
                                >
                                  <div
                                    className="clonable-block"
                                    data-toggle="cloner"
                                  >
                                    <div
                                      className="clonable"
                                      data-clone-number={sampleIndex + 1}
                                    >
                                      <div className="info-heading">
                                        <h2 className="pb-0">
                                          Serial number {sampleIndex + 1}
                                        </h2>
                                      </div>

                                      <div className="info-content">
                                        <div className="table-responsive mt-2 mb-2">
                                          <table className="table table-striped product_table start_table">
                                            <thead> </thead>

                                            <tbody>
                                              <div>
                                                {sample.labENVTestDetails &&
                                                  sample.labENVTestDetails
                                                    .filter((test: any) => {
                                                      const isValidTest =
                                                        test.isThirdPartyLab ===
                                                          1 &&
                                                        test.thirdPartyNric ===
                                                          customerNRIC &&
                                                        test.rowId ===
                                                          testRowId &&
                                                        (test.testStatus ===
                                                          null ||
                                                          test.testStatus !==
                                                            8);

                                                      return isValidTest;
                                                    })
                                                    .map((test, testIndex) => (
                                                      <tr
                                                        key={`test-row-${sampleIndex}-${test.labTestID}`}
                                                      >
                                                        <td className="br-1">
                                                          <div className="mb-3">
                                                            <div className="mb-2">
                                                              <div className="heading-test d-flex align-items-center justify-content-between">
                                                                <h2 className="pb-0 m-0">
                                                                  <div
                                                                    id={`testDescription-${sampleIndex}-${test.labTestID}`}
                                                                    className="test-description"
                                                                    dangerouslySetInnerHTML={{
                                                                      __html:
                                                                        test.testDescription,
                                                                    }}
                                                                  />
                                                                </h2>
                                                              </div>
                                                            </div>
                                                          </div>

                                                          <div className="info-content">
                                                            <div className="table table-striped product_table start_table">
                                                              <div className="d-flex flex-row justify-content-between align-items-center">
                                                                <div className="d-flex flex-column">
                                                                  <div className="d-flex flex-row align-items-center mt-2 mt-lg-0">
                                                                    <div className="col-lg-5">
                                                                      <label
                                                                        className="form-check-label"
                                                                        htmlFor="sampleMarking"
                                                                      >
                                                                        Sample
                                                                        Marking
                                                                      </label>
                                                                    </div>
                                                                    <div className="col-lg-7">
                                                                      <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder=""
                                                                        value={
                                                                          sample?.sampleMarking
                                                                        }
                                                                        name="sampleMarking"
                                                                        disabled
                                                                      />
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                                <div className="d-flex flex-column">
                                                                  <div className="d-flex flex-row align-items-center">
                                                                    <div className="col-lg-5">
                                                                      <label
                                                                        htmlFor="supportDocuments"
                                                                        className="form-check-label"
                                                                        onMouseEnter={
                                                                          handleMouseEnter
                                                                        }
                                                                        onMouseLeave={
                                                                          handleMouseLeave
                                                                        }
                                                                        title="Documents allowed:pdf,docx,doc,jpg,jpeg,png,xlsx,xls."
                                                                      >
                                                                        Result
                                                                        Documents
                                                                        <span
                                                                      className="csp-ml-5"
                                                                        >
                                                                          <FontAwesomeIcon
                                                                            icon={
                                                                              faInfoCircle
                                                                            }
                                                                          />
                                                                        </span>
                                                                      </label>
                                                                    </div>
                                                                    <div className="col-lg-7">
                                                                      <input
                                                                        type="file"
                                                                        className="form-control"
                                                                        id="ResultDocuments"
                                                                        disabled={
                                                                          amendCase ==
                                                                            "CASE4" ||
                                                                          isCancelRequest ||
                                                                          IsAcknowledgeRequest ||
                                                                          IsAcknowledge
                                                                        }
                                                                        onChange={(
                                                                          e
                                                                        ) =>
                                                                          handledFiledChange(
                                                                            sampleIndex,
                                                                            test.labTestID ??
                                                                              "",

                                                                            e
                                                                          )
                                                                        }
                                                                        multiple
                                                                      />

                                                                      {test?.ResultDocumentName ? (
                                                                        <div className="file-view">
                                                                          {
                                                                            test?.ResultDocumentName
                                                                          }
                                                                        </div>
                                                                      ) : (
                                                                        ""
                                                                      )}
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>

                                                            <div className="row">
                                                              {test.labENVTestResult &&
                                                                test
                                                                  .labENVTestResult
                                                                  .length > 0 &&
                                                                test.labENVTestResult.map(
                                                                  (
                                                                    result,
                                                                    resultIndex
                                                                  ) => (
                                                                    <div
                                                                      className="row mt-2"
                                                                      key={`result-${
                                                                        test.labTestID ||
                                                                        "default"
                                                                      }-${resultIndex}`}
                                                                    >
                                                                      {IsSubmitresultRequest && (
                                                                        <>
                                                                          <div className="info-heading">
                                                                            <ul className="card-icons float-end">
                                                                              <li>
                                                                                <button
                                                                                  className="icon-button"
                                                                                  title="New"
                                                                                  onClick={() =>
                                                                                    handleAddTestResult(
                                                                                      sampleIndex,
                                                                                      test.labTestID ??
                                                                                        ""
                                                                                    )
                                                                                  }
                                                                                >
                                                                                  <FontAwesomeIcon
                                                                                    icon={
                                                                                      faPlus
                                                                                    }
                                                                                  />
                                                                                </button>
                                                                              </li>
                                                                              <li className="copy-button-container">
                                                                                <button
                                                                                  className="icon-button"
                                                                                  title="Copy"
                                                                                  onClick={() =>
                                                                                    handledCopyButtonClick(
                                                                                      sampleIndex,
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )
                                                                                  }
                                                                                >
                                                                                  <FontAwesomeIcon
                                                                                    icon={
                                                                                      faCopy
                                                                                    }
                                                                                  />
                                                                                </button>
                                                                              </li>
                                                                              {resultIndex !==
                                                                                0 && (
                                                                                <li>
                                                                                  <button
                                                                                    className="icon-button"
                                                                                    onClick={() =>
                                                                                      handleDeleteTestResult(
                                                                                        sampleIndex,
                                                                                        test.labTestID ??
                                                                                          "",
                                                                                        resultIndex
                                                                                      )
                                                                                    }
                                                                                    title="Delete"
                                                                                  >
                                                                                    <FontAwesomeIcon
                                                                                      icon={
                                                                                        faTrashCan
                                                                                      }
                                                                                    />
                                                                                  </button>
                                                                                </li>
                                                                              )}
                                                                            </ul>
                                                                            <h2 className="labresults-heading">
                                                                              {resultIndex ===
                                                                              0
                                                                                ? "Test Result"
                                                                                : `Additional Result ${resultIndex}`}
                                                                            </h2>
                                                                          </div>
                                                                        </>
                                                                      )}

                                                                      <>
                                                                        {test.isPostMartem ===
                                                                          0 && (
                                                                          <>
                                                                            <div className="row align-items-center">
                                                                              <div className="col-lg-6">
                                                                                <label
                                                                                  className="form-check-label"
                                                                                  htmlFor={`resultcode-${sampleIndex}-${test.labTestID}-${resultIndex}`}
                                                                                >
                                                                                  Result
                                                                                  Code
                                                                                  <span className="star-red">
                                                                                    *
                                                                                  </span>
                                                                                </label>
                                                                                <Select
                                                                                  classNamePrefix="rs"
                                                                                  options={
                                                                                    ResultCodeOptions
                                                                                  }
                                                                                  value={
                                                                                    ResultCodeOptions.find(
                                                                                      (
                                                                                        option
                                                                                      ) =>
                                                                                        option.value ===
                                                                                        result.resultcode
                                                                                    ) ||
                                                                                    null
                                                                                  }
                                                                                  isDisabled={
                                                                                    amendCase ===
                                                                                      "CASE4" ||
                                                                                    isCancelRequest ||
                                                                                    IsAcknowledgeRequest ||
                                                                                    IsAcknowledge
                                                                                  }
                                                                                  onChange={handledSelectChange(
                                                                                    sampleIndex,
                                                                                    "resultcode",
                                                                                    test.labTestID ??
                                                                                      "",
                                                                                    resultIndex
                                                                                  )}
                                                                                />
                                                                                {result?.resultcodeErrMsg && (
                                                                                  <div className="error-message">
                                                                                    <FontAwesomeIcon
                                                                                      className="me-1"
                                                                                      icon={
                                                                                        faCircleExclamation
                                                                                      }
                                                                                    />
                                                                                    Please
                                                                                    fill
                                                                                    Result
                                                                                    Code.
                                                                                  </div>
                                                                                )}
                                                                              </div>

                                                                              <div className="col-lg-6">
                                                                                <label className="form-check-label">
                                                                                  Units
                                                                                </label>
                                                                                <textarea
                                                                                  id="units"
                                                                                  className="form-control"
                                                                                  name="units"
                                                                                  value={
                                                                                    result?.units ||
                                                                                    ""
                                                                                  }
                                                                                  maxLength={
                                                                                    100
                                                                                  }
                                                                                  disabled={
                                                                                    amendCase ===
                                                                                      "CASE4" ||
                                                                                    isCancelRequest ||
                                                                                    IsAcknowledgeRequest ||
                                                                                    IsAcknowledge
                                                                                  }
                                                                                  onChange={handledSamplesAndTestsChange(
                                                                                    sampleIndex,
                                                                                    "string",
                                                                                    test.labTestID ??
                                                                                      "",
                                                                                    resultIndex
                                                                                  )}
                                                                                />
                                                                              </div>
                                                                            </div>

                                                                            <div className="row">
                                                                              <div className="col-lg-6">
                                                                                <label className="form-check-label">
                                                                                  Testing
                                                                                  Instructions
                                                                                  <span className="star-red">
                                                                                    *
                                                                                  </span>
                                                                                </label>
                                                                                <textarea
                                                                                  id="testingInstruction"
                                                                                  className="form-control"
                                                                                  name="testingInstructions"
                                                                                  value={
                                                                                    result?.testingInstructions ||
                                                                                    ""
                                                                                  }
                                                                                  maxLength={
                                                                                    100
                                                                                  }
                                                                                  disabled={
                                                                                    amendCase ===
                                                                                      "CASE4" ||
                                                                                    isCancelRequest ||
                                                                                    IsAcknowledgeRequest ||
                                                                                    IsAcknowledge
                                                                                  }
                                                                                  onChange={handledSamplesAndTestsChange(
                                                                                    sampleIndex,
                                                                                    "string",
                                                                                    test.labTestID ??
                                                                                      "",
                                                                                    resultIndex
                                                                                  )}
                                                                                />

                                                                                {result?.testingInstructionsErrMsg && (
                                                                                  <div className="error-message">
                                                                                    <FontAwesomeIcon
                                                                                      className="me-1"
                                                                                      icon={
                                                                                        faCircleExclamation
                                                                                      }
                                                                                    />
                                                                                    Please
                                                                                    fill
                                                                                    Testing
                                                                                    Instructions.
                                                                                  </div>
                                                                                )}
                                                                              </div>

                                                                              <div className="col-lg-6">
                                                                                <label className="form-check-label">
                                                                                  Remarks
                                                                                  for
                                                                                  Third
                                                                                  Party
                                                                                  Laboratory
                                                                                  <span className="star-red">
                                                                                    *
                                                                                  </span>
                                                                                </label>
                                                                                <textarea
                                                                                  id="remarksForThirdParty"
                                                                                  className="form-control"
                                                                                  name="remarksForThirdParty"
                                                                                  value={
                                                                                    result?.remarksForThirdParty ||
                                                                                    ""
                                                                                  }
                                                                                  maxLength={
                                                                                    100
                                                                                  }
                                                                                  disabled={
                                                                                    amendCase ===
                                                                                      "CASE4" ||
                                                                                    isCancelRequest ||
                                                                                    IsAcknowledgeRequest ||
                                                                                    IsAcknowledge
                                                                                  }
                                                                                  onChange={handledSamplesAndTestsChange(
                                                                                    sampleIndex,
                                                                                    "string",
                                                                                    test.labTestID ??
                                                                                      "",
                                                                                    resultIndex
                                                                                  )}
                                                                                />
                                                                                {result?.remarksForThirdPartyErrMsg && (
                                                                                  <div className="error-message">
                                                                                    <FontAwesomeIcon
                                                                                      className="me-1"
                                                                                      icon={
                                                                                        faCircleExclamation
                                                                                      }
                                                                                    />
                                                                                    Please
                                                                                    fill
                                                                                    Remarks
                                                                                    for
                                                                                    Third
                                                                                    Party
                                                                                    Laboratory.
                                                                                  </div>
                                                                                )}
                                                                              </div>
                                                                            </div>

                                                                            <div className="row">
                                                                              <div className="col-lg-3">
                                                                                <label className="form-check-label">
                                                                                  Symbol
                                                                                  1
                                                                                </label>
                                                                                <select
                                                                                  className="form-select"
                                                                                  name="Symbol1"
                                                                                  value={
                                                                                    result?.Symbol1 ||
                                                                                    ""
                                                                                  }
                                                                                  disabled={
                                                                                    amendCase ==
                                                                                      "CASE4" ||
                                                                                    isCancelRequest ||
                                                                                    IsAcknowledgeRequest ||
                                                                                    IsAcknowledge
                                                                                  }
                                                                                  onChange={handledSamplesAndTestsChange(
                                                                                    sampleIndex,
                                                                                    "number",
                                                                                    test.labTestID ??
                                                                                      "",
                                                                                    resultIndex
                                                                                  )}
                                                                                >
                                                                                  <option value="">
                                                                                    Select
                                                                                  </option>
                                                                                  <option value="1">
                                                                                    &lt;
                                                                                  </option>
                                                                                  <option value="2">
                                                                                    &gt;
                                                                                  </option>
                                                                                  <option value="3">
                                                                                    +
                                                                                  </option>
                                                                                  <option value="4">
                                                                                    -
                                                                                  </option>
                                                                                </select>
                                                                              </div>
                                                                              <div className="col-lg-3">
                                                                                <label className="form-check-label">
                                                                                  Readings
                                                                                  1
                                                                                </label>
                                                                                <input
                                                                                  type="number"
                                                                                  className="form-control"
                                                                                  name="Readings"
                                                                                  step="0.01"
                                                                                  disabled={
                                                                                    isCancelRequest ||
                                                                                    IsAcknowledgeRequest ||
                                                                                    IsAcknowledge
                                                                                  }
                                                                                  maxLength={
                                                                                    100
                                                                                  }
                                                                                  value={
                                                                                    result?.Readings ||
                                                                                    0
                                                                                  }
                                                                                  onChange={handledSamplesAndTestsChange(
                                                                                    sampleIndex,
                                                                                    "decimal",
                                                                                    test.labTestID ??
                                                                                      "",
                                                                                    resultIndex
                                                                                  )}
                                                                                />
                                                                              </div>
                                                                              <div className="col-lg-3">
                                                                                <label className="form-check-label">
                                                                                  Symbol
                                                                                  2
                                                                                </label>
                                                                                <select
                                                                                  className="form-select"
                                                                                  name="Symbol2"
                                                                                  value={
                                                                                    result?.Symbol2 ||
                                                                                    ""
                                                                                  }
                                                                                  disabled={
                                                                                    amendCase ==
                                                                                      "CASE4" ||
                                                                                    isCancelRequest ||
                                                                                    IsAcknowledgeRequest ||
                                                                                    IsAcknowledge
                                                                                  }
                                                                                  onChange={handledSamplesAndTestsChange(
                                                                                    sampleIndex,
                                                                                    "number",
                                                                                    test.labTestID ??
                                                                                      "",
                                                                                    resultIndex
                                                                                  )}
                                                                                >
                                                                                  <option value="">
                                                                                    Select
                                                                                  </option>
                                                                                  <option value="1">
                                                                                    E
                                                                                  </option>
                                                                                  <option value="2">
                                                                                    /
                                                                                  </option>
                                                                                </select>
                                                                              </div>

                                                                              <div className="col-lg-3">
                                                                                <label className="form-check-label">
                                                                                  Reading
                                                                                  2
                                                                                </label>
                                                                                <input
                                                                                  type="number"
                                                                                  className="form-control"
                                                                                  name="Readings2"
                                                                                  step="0.01"
                                                                                  disabled={
                                                                                    amendCase ==
                                                                                      "CASE4" ||
                                                                                    isCancelRequest ||
                                                                                    IsAcknowledgeRequest ||
                                                                                    IsAcknowledge
                                                                                  }
                                                                                  maxLength={
                                                                                    100
                                                                                  }
                                                                                  value={
                                                                                    result?.Readings2 ||
                                                                                    0
                                                                                  }
                                                                                  onChange={handledSamplesAndTestsChange(
                                                                                    sampleIndex,
                                                                                    "decimal",
                                                                                    test.labTestID ??
                                                                                      "",
                                                                                    resultIndex
                                                                                  )}
                                                                                />
                                                                              </div>
                                                                            </div>

                                                                            <div className="row">
                                                                              <div className="col-lg-3">
                                                                                <label htmlFor="Positive">
                                                                                  Positive
                                                                                </label>
                                                                                <input
                                                                                  type="text"
                                                                                  id="Positive"
                                                                                  className="form-control"
                                                                                  name="Positive"
                                                                                  value={
                                                                                    result?.Positive ||
                                                                                    ""
                                                                                  }
                                                                                  maxLength={
                                                                                    100
                                                                                  }
                                                                                  disabled={
                                                                                    amendCase ===
                                                                                      "CASE4" ||
                                                                                    isCancelRequest ||
                                                                                    IsAcknowledgeRequest ||
                                                                                    IsAcknowledge
                                                                                  }
                                                                                  onChange={handledSamplesAndTestsChange(
                                                                                    sampleIndex,
                                                                                    "string",
                                                                                    test.labTestID ??
                                                                                      "",
                                                                                    resultIndex
                                                                                  )}
                                                                                />
                                                                              </div>

                                                                              <div className="col-lg-3">
                                                                                <label htmlFor="Negative">
                                                                                  Negative
                                                                                </label>
                                                                                <input
                                                                                  type="text"
                                                                                  className="form-control"
                                                                                  name="Negative"
                                                                                  value={
                                                                                    result?.Negative ||
                                                                                    ""
                                                                                  }
                                                                                  maxLength={
                                                                                    100
                                                                                  }
                                                                                  disabled={
                                                                                    amendCase ===
                                                                                      "CASE4" ||
                                                                                    isCancelRequest ||
                                                                                    IsAcknowledgeRequest ||
                                                                                    IsAcknowledge
                                                                                  }
                                                                                  onChange={handledSamplesAndTestsChange(
                                                                                    sampleIndex,
                                                                                    "string",
                                                                                    test.labTestID ??
                                                                                      "",
                                                                                    resultIndex
                                                                                  )}
                                                                                />
                                                                              </div>

                                                                              <div className="col-lg-3">
                                                                                <label htmlFor="Indefinite">
                                                                                  Indefinite
                                                                                </label>
                                                                                <input
                                                                                  type="text"
                                                                                  id="Indefinite"
                                                                                  className="form-control"
                                                                                  name="Indefinite"
                                                                                  value={
                                                                                    result?.Indefinite ||
                                                                                    ""
                                                                                  }
                                                                                  maxLength={
                                                                                    100
                                                                                  }
                                                                                  disabled={
                                                                                    amendCase ===
                                                                                      "CASE4" ||
                                                                                    isCancelRequest ||
                                                                                    IsAcknowledgeRequest ||
                                                                                    IsAcknowledge
                                                                                  }
                                                                                  onChange={handledSamplesAndTestsChange(
                                                                                    sampleIndex,
                                                                                    "string",
                                                                                    test.labTestID ??
                                                                                      "",
                                                                                    resultIndex
                                                                                  )}
                                                                                />
                                                                              </div>

                                                                              <div className="col-lg-3">
                                                                                <label htmlFor="ResultRemarks">
                                                                                  Remarks
                                                                                </label>
                                                                                <input
                                                                                  type="text"
                                                                                  className="form-control"
                                                                                  name="ResultRemarks"
                                                                                  value={
                                                                                    result?.ResultRemarks ||
                                                                                    ""
                                                                                  }
                                                                                  maxLength={
                                                                                    100
                                                                                  }
                                                                                  disabled={
                                                                                    amendCase ===
                                                                                      "CASE4" ||
                                                                                    isCancelRequest ||
                                                                                    IsAcknowledgeRequest ||
                                                                                    IsAcknowledge
                                                                                  }
                                                                                  onChange={handledSamplesAndTestsChange(
                                                                                    sampleIndex,
                                                                                    "string",
                                                                                    test.labTestID ??
                                                                                      "",
                                                                                    resultIndex
                                                                                  )}
                                                                                />
                                                                              </div>
                                                                            </div>
                                                                          </>
                                                                        )}
                                                                      </>
                                                                      <>
                                                                        {test.isPostMartem ===
                                                                          1 && (
                                                                          <>
                                                                            <div className="row">
                                                                              <div className="col-lg-6">
                                                                                <div className="row mt-2 mt-lg-0">
                                                                                  <div className="col-lg-5">
                                                                                    <label
                                                                                      className="form-check-label"
                                                                                      htmlFor={`resultcode-${sampleIndex}-${test.labTestID}-${resultIndex}`}
                                                                                    >
                                                                                      Result
                                                                                      Code
                                                                                      <span className="star-red">
                                                                                        *
                                                                                      </span>
                                                                                    </label>
                                                                                  </div>
                                                                                  <div className="col-lg-7">
                                                                                    <Select
                                                                                      classNamePrefix="rs"
                                                                                      options={
                                                                                        ResultCodeOptions
                                                                                      }
                                                                                      value={
                                                                                        ResultCodeOptions.find(
                                                                                          (
                                                                                            option
                                                                                          ) =>
                                                                                            option.value ===
                                                                                            result.resultcode
                                                                                        ) ||
                                                                                        null
                                                                                      }
                                                                                      isDisabled={
                                                                                        amendCase ==
                                                                                          "CASE4" ||
                                                                                        isCancelRequest ||
                                                                                        IsAcknowledgeRequest ||
                                                                                        IsAcknowledge
                                                                                      }
                                                                                      onChange={handledSelectChange(
                                                                                        sampleIndex,
                                                                                        "resultcode",
                                                                                        test.labTestID ??
                                                                                          "",
                                                                                        resultIndex
                                                                                      )}
                                                                                    />
                                                                                    {result?.resultcodeErrMsg && (
                                                                                      <div className="error-message">
                                                                                        <FontAwesomeIcon
                                                                                          className="me-1"
                                                                                          icon={
                                                                                            faCircleExclamation
                                                                                          }
                                                                                        />
                                                                                        Please
                                                                                        fill
                                                                                        Result
                                                                                        Code
                                                                                      </div>
                                                                                    )}
                                                                                  </div>
                                                                                </div>
                                                                              </div>

                                                                              <div className="col-lg-6">
                                                                                <div className="row">
                                                                                  <div className="col-lg-5">
                                                                                    <label
                                                                                      className="form-check-label"
                                                                                      htmlFor={`units-${sampleIndex}-${test.labTestID}`}
                                                                                    >
                                                                                      Units
                                                                                    </label>
                                                                                  </div>
                                                                                  <div className="col-lg-7">
                                                                                    <textarea
                                                                                      className="form-control"
                                                                                      name="units"
                                                                                      value={
                                                                                        result?.units ||
                                                                                        ""
                                                                                      }
                                                                                      maxLength={
                                                                                        500
                                                                                      }
                                                                                      disabled={
                                                                                        amendCase ==
                                                                                          "CASE4" ||
                                                                                        isCancelRequest ||
                                                                                        IsAcknowledgeRequest ||
                                                                                        IsAcknowledge
                                                                                      }
                                                                                      onChange={handledSamplesAndTestsChange(
                                                                                        sampleIndex,
                                                                                        "string",
                                                                                        test.labTestID ??
                                                                                          "",
                                                                                        resultIndex
                                                                                      )}
                                                                                    />
                                                                                  </div>
                                                                                </div>
                                                                              </div>
                                                                            </div>

                                                                            <div className="row">
                                                                              <div className="col-lg-6">
                                                                                <div className="row">
                                                                                  <div className="col-lg-5">
                                                                                    <label
                                                                                      className="form-check-label"
                                                                                      htmlFor={`testingInstructions-${sampleIndex}-${test.labTestID}`}
                                                                                    >
                                                                                      Testing
                                                                                      Instructions
                                                                                      <span className="star-red">
                                                                                        *
                                                                                      </span>
                                                                                    </label>
                                                                                  </div>
                                                                                  <div className="col-lg-7">
                                                                                    <textarea
                                                                                      className="form-control"
                                                                                      name="testingInstructions"
                                                                                      value={
                                                                                        result?.testingInstructions ||
                                                                                        ""
                                                                                      }
                                                                                      maxLength={
                                                                                        500
                                                                                      }
                                                                                      disabled={
                                                                                        amendCase ==
                                                                                          "CASE4" ||
                                                                                        isCancelRequest ||
                                                                                        IsAcknowledgeRequest ||
                                                                                        IsAcknowledge
                                                                                      }
                                                                                      onChange={handledSamplesAndTestsChange(
                                                                                        sampleIndex,
                                                                                        "string",
                                                                                        test.labTestID ??
                                                                                          "",
                                                                                        resultIndex
                                                                                      )}
                                                                                    />
                                                                                    {result?.testingInstructionsErrMsg && (
                                                                                      <div className="error-message">
                                                                                        <FontAwesomeIcon
                                                                                          className="me-1"
                                                                                          icon={
                                                                                            faCircleExclamation
                                                                                          }
                                                                                        />
                                                                                        Please
                                                                                        fill
                                                                                        Testing
                                                                                        Instructions.
                                                                                      </div>
                                                                                    )}
                                                                                  </div>
                                                                                </div>
                                                                              </div>
                                                                              <div className="col-lg-6">
                                                                                <div className="row mt-2 mt-lg-0">
                                                                                  <div className="col-lg-5">
                                                                                    <label
                                                                                      className="form-check-label"
                                                                                      htmlFor="remarksForThirdParty"
                                                                                    >
                                                                                      Remarks
                                                                                      for
                                                                                      Third
                                                                                      Party
                                                                                      Laboratory{" "}
                                                                                      <span className="star-red">
                                                                                        *
                                                                                      </span>
                                                                                    </label>
                                                                                  </div>
                                                                                  <div className="col-lg-7">
                                                                                    <textarea
                                                                                      className="form-control"
                                                                                      name="remarksForThirdParty"
                                                                                      value={
                                                                                        result?.remarksForThirdParty ||
                                                                                        ""
                                                                                      }
                                                                                      disabled={
                                                                                        amendCase ==
                                                                                          "CASE4" ||
                                                                                        isCancelRequest ||
                                                                                        IsAcknowledgeRequest ||
                                                                                        IsAcknowledge
                                                                                      }
                                                                                      maxLength={
                                                                                        500
                                                                                      }
                                                                                      onChange={handledSamplesAndTestsChange(
                                                                                        sampleIndex,
                                                                                        "string",
                                                                                        test.labTestID ??
                                                                                          "",
                                                                                        resultIndex
                                                                                      )}
                                                                                    />

                                                                                    {result?.remarksForThirdPartyErrMsg && (
                                                                                      <div className="error-message">
                                                                                        <FontAwesomeIcon
                                                                                          className="me-1"
                                                                                          icon={
                                                                                            faCircleExclamation
                                                                                          }
                                                                                        />
                                                                                        Please
                                                                                        fill
                                                                                        Remarks
                                                                                        for
                                                                                        Third
                                                                                        Party
                                                                                        Laboratory.
                                                                                      </div>
                                                                                    )}
                                                                                  </div>
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                            <div className="row">
                                                                              <div className="col-lg-6">
                                                                                <div className="row">
                                                                                  <div className="col-lg-5">
                                                                                    <label
                                                                                      className="form-check-label"
                                                                                      htmlFor={`report-${sampleIndex}-${test.labTestID}`}
                                                                                    >
                                                                                      Report
                                                                                    </label>
                                                                                  </div>
                                                                                  <div className="col-lg-7">
                                                                                    <textarea
                                                                                      className="form-control"
                                                                                      name="report"
                                                                                      value={
                                                                                        result?.report ||
                                                                                        ""
                                                                                      }
                                                                                      maxLength={
                                                                                        500
                                                                                      }
                                                                                      disabled={
                                                                                        amendCase ==
                                                                                          "CASE4" ||
                                                                                        isCancelRequest ||
                                                                                        IsAcknowledgeRequest ||
                                                                                        IsAcknowledge
                                                                                      }
                                                                                      onChange={handledSamplesAndTestsChange(
                                                                                        sampleIndex,
                                                                                        "string",
                                                                                        test.labTestID ??
                                                                                          "",
                                                                                        resultIndex
                                                                                      )}
                                                                                    />
                                                                                  </div>
                                                                                </div>
                                                                              </div>
                                                                              <div className="col-lg-6">
                                                                                <div className="row mt-2 mt-lg-0">
                                                                                  <div className="col-lg-5">
                                                                                    <label
                                                                                      className="form-check-label"
                                                                                      htmlFor="Parasitology"
                                                                                    >
                                                                                      Parasitology
                                                                                    </label>
                                                                                  </div>
                                                                                  <div className="col-lg-7">
                                                                                    <textarea
                                                                                      className="form-control"
                                                                                      name="Parasitology"
                                                                                      value={
                                                                                        result?.Parasitology ||
                                                                                        ""
                                                                                      }
                                                                                      disabled={
                                                                                        amendCase ==
                                                                                          "CASE4" ||
                                                                                        isCancelRequest ||
                                                                                        IsAcknowledgeRequest ||
                                                                                        IsAcknowledge
                                                                                      }
                                                                                      maxLength={
                                                                                        500
                                                                                      }
                                                                                      onChange={handledSamplesAndTestsChange(
                                                                                        sampleIndex,
                                                                                        "string",
                                                                                        test.labTestID ??
                                                                                          "",
                                                                                        resultIndex
                                                                                      )}
                                                                                    />
                                                                                  </div>
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                            <div className="row">
                                                                              <div className="col-lg-6">
                                                                                <div className="row">
                                                                                  <div className="col-lg-5">
                                                                                    <label
                                                                                      className="form-check-label"
                                                                                      htmlFor="Microbiology"
                                                                                    >
                                                                                      Microbiology
                                                                                    </label>
                                                                                  </div>
                                                                                  <div className="col-lg-7">
                                                                                    <textarea
                                                                                      className="form-control"
                                                                                      name="Microbiology"
                                                                                      value={
                                                                                        result?.Microbiology ||
                                                                                        ""
                                                                                      }
                                                                                      maxLength={
                                                                                        500
                                                                                      }
                                                                                      disabled={
                                                                                        amendCase ==
                                                                                          "CASE4" ||
                                                                                        isCancelRequest ||
                                                                                        IsAcknowledgeRequest ||
                                                                                        IsAcknowledge
                                                                                      }
                                                                                      onChange={handledSamplesAndTestsChange(
                                                                                        sampleIndex,
                                                                                        "string",
                                                                                        test.labTestID ??
                                                                                          "",
                                                                                        resultIndex
                                                                                      )}
                                                                                    />
                                                                                  </div>
                                                                                </div>
                                                                              </div>
                                                                              <div className="col-lg-6">
                                                                                <div className="row mt-2 mt-lg-0">
                                                                                  <div className="col-lg-5">
                                                                                    <label
                                                                                      className="form-check-label"
                                                                                      htmlFor="Histopathology"
                                                                                    >
                                                                                      Histopathology
                                                                                    </label>
                                                                                  </div>
                                                                                  <div className="col-lg-7">
                                                                                    <textarea
                                                                                      className="form-control"
                                                                                      name="Histopathology"
                                                                                      value={
                                                                                        result?.Histopathology ||
                                                                                        ""
                                                                                      }
                                                                                      maxLength={
                                                                                        500
                                                                                      }
                                                                                      onChange={handledSamplesAndTestsChange(
                                                                                        sampleIndex,
                                                                                        "string",
                                                                                        test.labTestID ??
                                                                                          "",
                                                                                        resultIndex
                                                                                      )}
                                                                                      disabled={
                                                                                        amendCase ==
                                                                                          "CASE4" ||
                                                                                        isCancelRequest ||
                                                                                        IsAcknowledgeRequest ||
                                                                                        IsAcknowledge
                                                                                      }
                                                                                    />
                                                                                  </div>
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                            <div className="row">
                                                                              <div className="col-lg-6">
                                                                                <div className="row">
                                                                                  <div className="col-lg-5">
                                                                                    <label
                                                                                      className="form-check-label"
                                                                                      htmlFor="ourreference"
                                                                                    >
                                                                                      Our
                                                                                      Reference
                                                                                    </label>
                                                                                  </div>
                                                                                  <div className="col-lg-7">
                                                                                    <textarea
                                                                                      className="form-control"
                                                                                      name="ourreference"
                                                                                      value={
                                                                                        result?.ourreference ||
                                                                                        ""
                                                                                      }
                                                                                      maxLength={
                                                                                        500
                                                                                      }
                                                                                      disabled={
                                                                                        amendCase ==
                                                                                          "CASE4" ||
                                                                                        isCancelRequest ||
                                                                                        IsAcknowledgeRequest ||
                                                                                        IsAcknowledge
                                                                                      }
                                                                                      onChange={handledSamplesAndTestsChange(
                                                                                        sampleIndex,
                                                                                        "string",
                                                                                        test.labTestID ??
                                                                                          "",
                                                                                        resultIndex
                                                                                      )}
                                                                                    />
                                                                                  </div>
                                                                                </div>
                                                                              </div>
                                                                              <div className="col-lg-6">
                                                                                <div className="row mt-2 mt-lg-0">
                                                                                  <div className="col-lg-5">
                                                                                    <label
                                                                                      className="form-check-label"
                                                                                      htmlFor="finalDiagnosis"
                                                                                    >
                                                                                      Final
                                                                                      Diagnosis
                                                                                    </label>
                                                                                  </div>
                                                                                  <div className="col-lg-7">
                                                                                    <textarea
                                                                                      className="form-control"
                                                                                      name="finalDiagnosis"
                                                                                      value={
                                                                                        result?.finalDiagnosis ||
                                                                                        ""
                                                                                      }
                                                                                      maxLength={
                                                                                        500
                                                                                      }
                                                                                      onChange={handledSamplesAndTestsChange(
                                                                                        sampleIndex,
                                                                                        "string",
                                                                                        test.labTestID ??
                                                                                          "",
                                                                                        resultIndex
                                                                                      )}
                                                                                      disabled={
                                                                                        amendCase ==
                                                                                          "CASE4" ||
                                                                                        isCancelRequest ||
                                                                                        IsAcknowledgeRequest ||
                                                                                        IsAcknowledge
                                                                                      }
                                                                                    />
                                                                                  </div>
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                          </>
                                                                        )}
                                                                      </>
                                                                    </div>
                                                                  )
                                                                )}
                                                            </div>
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    ))}
                                              </div>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          )}
                      <br />
                    </Tab>
                  )}
                </Tabs>

                {showAmendmentHistory && amendmentHistory?.length > 0 && (
                  <AmendmentGrid
                    data={amendmentHistory}
                    setData={setAmendmentHistory}
                    isLoading
                  />
                )}

                <div className="text-end mt-3 mb-3">
                  {!IsSubmitresultRequest && !IsAcknowledge ? (
                    <button
                      className="btn btn-d btn-secondary px-4"
                      onClick={handlePreviousClick}
                    >
                      Previous
                    </button>
                  ) : null}
                  {(IsSubmitresultRequest || IsAcknowledge) && (
                    <>
                      <button
                        className="btn btn-d btn-secondary px-4"
                        onClick={handledPreviousClick}
                      >
                        Previous
                      </button>

                      <button
                        className="btn btn-d btn-primary px-4"
                        onClick={
                          IsSubmitresultRequest
                            ? handledSaveResultClick
                            : handleACKResultClick
                        }
                      >
                        {IsSubmitresultRequest ? "Submit" : "Acknowledge"}
                      </button>
                    </>
                  )}

                  {!IsAcknowledgeRequest &&
                    !isCancelRequest &&
                    !IsAcknowledge &&
                    !IsSubmitresultRequest && (
                      <>
                        {actionType !== TypeOfApplicationEnum.amendment && (
                          <button
                            className="btn btn-d btn-secondry  px-4"
                            onClick={handleSaveDraftClick}
                            disabled={btnNameForLoader === "submit-req"}
                          >
                            {btnNameForLoader === "submit-req"
                              ? "Submitting..."
                              : "Save Draft"}
                          </button>
                        )}

                        <button
                          className="btn btn-d btn-primary nextBtn"
                          name="next-click"
                          type="button"
                          onClick={validateForm}
                        >
                          Next
                          {btnNameForLoader == "next-click" ? (
                            <Spinner
                              className="btn-spinner"
                              animation="border"
                              variant="light"
                            />
                          ) : (
                            ""
                          )}
                        </button>
                      </>
                    )}
                  {!IsAcknowledgeRequest &&
                    !IsSubmitresultRequest &&
                    !IsAcknowledge &&
                    !cancelButtonHidden &&
                    isCancelRequest && (
                      <button
                        className="btn btn-d btn-primary nextBtn"
                        name="cancel-request-btn"
                        type="button"
                        onClick={cancelRequest}
                        disabled={btnNameForLoader === "cancel-request-btn"}
                      >
                        Cancel Request
                        {btnNameForLoader == "cancel-request-btn" ? (
                          <Spinner
                            className="btn-spinner"
                            animation="border"
                            variant="light"
                          />
                        ) : (
                          ""
                        )}
                      </button>
                    )}
                </div>
              </div>
            </div>
          </div>
        )}
      </Container>
      {amendCase === "CASE4" ||
      IsAcknowledgeRequest ||
      IsSubmitresultRequest ||
      isCancelRequest ? (
        ""
      ) : (
        <Modal
          className="popup-2"
          show={showSearchTestsModal}
          onHide={handleCloseSearchTestsModal}
          backdrop="static"
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Assign Tests</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleFormSubmit}>
              <h3>Search for Tests</h3>
              <div className="tests-cnt pb-2">
                <div className="mb-3 row">
                  <label
                    htmlFor="flexCheckDesc"
                    className="col-sm-3 col-form-label"
                  >
                    Test Laboratory
                    <span className="star-red">*</span>
                  </label>
                  <div className="col-sm-9">
                    <select
                      className="form-select"
                      aria-label="Test Laboratory"
                      value={selectedTestLaboratory}
                      disabled={amendCase == "CASE4" || isCancelRequest}
                      onChange={(e) => {
                        setSelectedTestLaboratory(e.target.value);
                      }}
                    >
                      <option selected value="All-laboratories">
                        All laboratories
                      </option>
                      {labtestoptions.map((item, index) => (
                        <option key={index} value={item.labGroup}>
                          {item.labGroup}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="mb-1 row"></div>
                <div className="mb-3 row">
                  <label
                    htmlFor="flexCheckDesc"
                    className="col-sm-3 col-form-label"
                  >
                    Test Description
                  </label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      id="flexCheckDesc"
                      placeholder=""
                      autoComplete="off"
                      value={testDescription}
                      required
                      onChange={(e) => setTestDescription(e.target.value)}
                      disabled={amendCase == "CASE4" || isCancelRequest}
                      className={`form-control ${
                        !testDescription ? "border-danger op05" : ""
                      }`}
                    />
                    <br />

                    <Button
                      variant="primary"
                      className="float-end"
                      name="submit-reqq"
                      disabled={searchLoading}
                      onClick={handleSearch}
                    >
                      Search
                      {btnNameForLoader == "submit-reqq" ? (
                        <Spinner
                          className="btn-spinner"
                          animation="border"
                          variant="light"
                        />
                      ) : (
                        ""
                      )}
                    </Button>
                  </div>
                </div>
              </div>
              <h3>Examination/Diagnostic Tests</h3>
              <div
                className="tests-cnt csp-maxh-200 csp-overflow-y-auto csp-display-block"
              >
                <h4>Examination/Diagnostic Tests</h4>
                {testOptions
                  .slice()
                  .sort((a, b) => {
                    const stripHtml = (text: any) =>
                      text.replace(/<[^>]*>/g, "").trim();
                    return stripHtml(a.description).localeCompare(
                      stripHtml(b.description)
                    );
                  })
                  .map((test, index) => (
                    <div className="form-check" key={index}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value={test.description}
                        id={`testOption${index}`}
                        checked={test.isSelected}
                        onChange={(e) =>
                          toggleTestSelection(
                            test.labCodeMasterID,
                            e.target.checked
                          )
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`testOption${index}`}
                        dangerouslySetInnerHTML={{ __html: test.description }}
                      ></label>
                    </div>
                  ))}
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseSearchTestsModal}>
              Close
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                handleAddTests();
                handleCloseSearchTestsModal();
              }}
            >
              Add
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <Footer />
    </>
  );
}

export default CAVSENVSampleDetails;
